

if (!sessionStorage.getItem('INCMUID')) {
  const sessionId = crypto.randomUUID(); // ou usar Date.now() + Math.random()
  sessionStorage.setItem('INCMUID', sessionId);
}
const INCMUID=sessionStorage.getItem('INCMUID');

// FUNÇÕES NOVAS

function storeRequestedQty(variantId, requestedQty) {
    let key = variantId.toString();
    let requestedMap = JSON.parse(localStorage.getItem('last_requested_qty') || '{}');
    let current = requestedMap[key] || 0;
    // Só acumula se a nova quantidade for maior (evita regredir)
    if (requestedQty > current) {
        requestedMap[key] = requestedQty;
    } else {
        // Se for menor, mantém o valor mais alto já registado (último total)
        // Ou podes substituir sempre – depende da lógica de negócio.
        // Para este caso, substituir é mais simples:
        requestedMap[key] = requestedQty;
    }
    localStorage.setItem('last_requested_qty', JSON.stringify(requestedMap));
}

function getStoredRequestedQty(variantId) {
    let key = variantId.toString();
    let requestedMap = JSON.parse(localStorage.getItem('last_requested_qty') || '{}');
    return requestedMap[key];
}

function removeStoredRequestedQty(variantId) {
    let key = variantId.toString();
    let requestedMap = JSON.parse(localStorage.getItem('last_requested_qty') || '{}');
    delete requestedMap[key];
    localStorage.setItem('last_requested_qty', JSON.stringify(requestedMap));
}

function showCartQuantityAlert(content) {
    var $cartError = $(".cart-error").first();

    if (!$cartError.length) {
        $cartError = $(
            '<div class="cart-error incm-cart-error" role="alert" aria-live="assertive">' +
                '<div class="content-error"></div>' +
            '</div>'
        ).appendTo("body");

        $cartError.css({
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 2147483647,
            maxWidth: "420px",
            padding: "16px 20px",
            color: "#fff",
            backgroundColor: "#b3261e",
            borderRadius: "4px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.25)",
            fontSize: "14px",
            lineHeight: "1.4",
            display: "none"
        });
    }

    if (
        typeof window.KT !== "undefined" &&
        typeof KT.errorAlert === "function"
    ) {
        KT.errorAlert(content);
    } else {
        $cartError
            .find(".content-error")
            .html(content);
    }

    $cartError
        .stop(true, true)
        .addClass("show")
        .show();

    clearTimeout(window.cartQuantityAlertTimeout);
    window.cartQuantityAlertTimeout = setTimeout(function() {
        $cartError.fadeOut(250, function() {
            $cartError.removeClass("show");
        });
    }, 10000);
}

function cleanStaleRequestedQty(cartItems) {
    let stored = JSON.parse(localStorage.getItem('last_requested_qty') || '{}');
    let cartVariantIds = cartItems.map(item => item.id.toString());
    for (let variantId in stored) {
        if (!cartVariantIds.includes(variantId)) {
            delete stored[variantId];
        }
    }
    localStorage.setItem('last_requested_qty', JSON.stringify(stored));
}

/* FIM DE FUNÇÕES NOVAS */
//

/* CUSTOMER REGISTRATION */

$(document).ready(function() {
  $("img.zoomImg").attr("alt","zoom Image")

  //console.log($('#product-photo-slide--product-template2 .swiper-slide-active img'))
 
  $('.denominacao_social input').on('input', function () {
    var $input = $(this);
    var maxLength = $input.attr('maxlength');

    setTimeout(function () {
        var currentLength = $input.val().length;

        if (currentLength >= maxLength) {
            //console.log("Max length reached");
            //$(".limit_reached").removeClass("d-none")
        } else {
            //$(".limit_reached").addClass("d-none")
            //console.log("Max length not reached");
        }
    }, 100); // Adjust the delay as needed
    if (window.location.pathname === "/cart") {
    // Limpar localStorage se não houver escolha ativa
    if ($(".choose_type").hasClass("d-none")) {
        localStorage.removeItem("b2b_prods");
        localStorage.removeItem("b2c_prods");
    }
}
});

  
  window.access_interval=setInterval(function(){
    
    $("img.zoomImg").removeAttr("role")
    if ($(".coi-banner__decline").length){
      $(".coi-banner__decline").removeAttr("aria-label").removeAttr("aria-atomic").removeAttr("role")
    }
    if ($(".coi-banner__policy").length){
      $(".coi-banner__policy").each(function(){
        $(this).attr("tabindex","0")
      })
    }
  },100)
  setTimeout(function(){
    clearInterval(window.access_interval)
  },10000)
  
  if ($("body[data-customer]").length){
  
     var customer = $("body[data-customer]").attr("data-customer");
     checkCustomerProfile(customer);
   } else {
     removeUpdateTags();

   }
  
  if($(".cartPage").length > 0){
    $(".cart_input_qnty").each(function(){
      var maxQnty = parseInt($(this).attr("max"));
      var currQnty = parseInt($(this).val());

      if(currQnty >= maxQnty && maxQnty > 0){
        $(this).parent().find(".qtyplus").addClass("d-none")
      }
    })
  }

  /*if($(".campo.change_nif").length){
    $(".campo.change_nif").click(function(){
      window.location.href = "/account";
    })
  }*/
  
/*
  var checker = setInterval(function(){
    if($(".panel-heading").length){
      console.log("done")
      FAQSliders();
      clearInterval(checker);
    } else {
      console.log("Doesnt exist")popup_livro_reclamacao_quantity
    }
  },50)*/

  //function FAQSliders(){
    $(".panel-heading").each(function(){
        let obj = $(this);
  
        obj.click(function(){
          let clicked = $(this);
          let parent = clicked.parent();
          let content = parent.find(".panel-collapse");
          if(content[0].style.display == "block"){
            content[0].style.display = "none";
          } else {
            content[0].style.display = "block";
          }
        })     
    })
  //}

/*
  $(".summary_warning").click(function(){
    if($(".summary_notes").hasClass("d-none")){
      $(".summary_notes").removeClass("d-none");  
    }else{
      $(".summary_notes").addClass("d-none");  
    }
    
  })*/

  $("#CustomerResetForm").submit(function(e) {
    var password = $("#singin-password").val();
    var password_confirmation = $("#singin-password_confirmation").val();

    if(password == password_confirmation){
      if(password.length >= 10){
        var temMaiuscula = false;
        var temMinuscula = false;
        var temDigito = false;
        var temCaraterEspecial = false;
        var temCaraterSeguidoIgual = false;
        var lowChar = "";
        var uppChar = "";
        var prevChar = "";
        var specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        var charChecked = false;

        for (var i = 0; i < password.length; i++) {
            charChecked = false;

            if (i > 0) {
                prevChar = password[i - 1];
                if (password[i] == prevChar) {
                    temCaraterSeguidoIgual = true;
                    break;
                }
            }

            if (temCaraterSeguidoIgual == false) {
                if (charChecked == false && temCaraterEspecial == false && specialChar.test(password[i])) {
                    temCaraterEspecial = true;
                    charChecked = true;
                } 
              
                if (charChecked == false && temDigito == false && isNumeric(password[i])) {
                    temDigito = true;
                    charChecked = true;
                } 
              
                if (charChecked == false && temMaiuscula == false && !isNumeric(password[i])) {
                    uppChar = password[i].toUpperCase();
                    if (password[i] == uppChar) {
                        temMaiuscula = true;
                        charChecked = true;
                    }
                }
              
                if (charChecked == false && temMinuscula == false && !isNumeric(password[i])) {
                    lowChar = password[i].toLowerCase();
                    if (password[i] == lowChar) {
                        temMinuscula = true;
                        charChecked = true;
                    }
                }
   
            }
        }

        if (temCaraterEspecial && temDigito && temMaiuscula && temMinuscula){
         
          e.stopPropagation();
          //return true;
        }
        else {
            if (temCaraterSeguidoIgual) {
                $(".feedback")
                    .html("Por favor certifique-se que a sua password não contém caracters iguais seguidos.")
                    .show();
            } else {
                $(".feedback")
                    .html("Por favor certifique-se que a sua password contém pelo menos uma letra maiúscula, uma letra minúscula, um dígito e um caracter especial.")
                    .show();
            }
            $("html, body")
                .stop()
                .animate({
                    scrollTop: 0
                }, 500, 'swing');
            return false;
        }        
      } else {
        $(".feedback")
              .html("Por favor certifique-se que a sua password contém pelo menos 10 caracteres.")
              .show();
        $("html, body")
                .stop()
                .animate({
                    scrollTop: 0
                }, 500, 'swing');
        return false
      }
    }
  });

  //console.log("dwdwdwdwd")
  //$(".item-slide picture").remove();
  
        function removeEmptyOwl() {
            $(".owl-item.active")
                .each(function() {
                    if ($(this)
                        .children()
                        .children()
                        .length == 0) {
                        $(this)
                            .remove();
                    }
                })
        }

        function owlLoaded() {
            return $(".owl-item.active")
                .length;
        }

        var checker = setInterval(function() {
            if (owlLoaded()) {
                removeEmptyOwl();
                clearInterval(checker);
            }
        }, 50)

        if($(".removeProduct").length > 0){
          $(".removeProduct").parent().on("submit", function(){
            alert("Este produto não pode ser adquirido com o seu perfil de cliente.");
            return false;
          })

          $(".add_B2B").on("click", function(e){
            if($(".add_B2B").attr("disabled") == undefined){
              e.stopPropagation();
              alert("Este produto não pode ser adquirido com o seu perfil de cliente.");
            return false;
            }
          })
        }

        if($("#cart-form--product-template2").length > 0){

            $("#cart-form--product-template2").on("submit", function(){
              if($(".not_ipq").length > 0){
                alert("Este produto não pode ser adquirido com o seu perfil de cliente.");
                return false;
              }
            })
        }
      
        $(document).click(function(target) {
                var content = new Object();
                content["data"] = new Object();
                content["data"] = $(target.target)[0].outerHTML;
                content["dataParent"] = $(target.target)
                    .parent()[0].outerHTML;

                if ($("form")
                    .length > 0) {
                    $("form")
                        .each((key, form) => {

                        })
                }

                SendTrackToMiddleware(content);
            })

        if ($(".input-qty").length > 0) {
          
            if ($(".input-qty").attr("step") > 1) {
              
                //$(".input-qty")[0].setAttribute("disabled", false);
                //$(".input-qty")[0].removeAttr("disabled")
            }
            $("#CartFormPage .cart_input_qnty").change(function() {
                    var inputQnty = $(this);
                    var id = parseInt(inputQnty.attr("data-vID"), 10);
                    if (isNaN(id)) {
                        console.warn("data-vID inválido, não será atualizado");
                        return;
                    }

                    var previousVal = parseInt(inputQnty.attr("value"), 10) || 0;
                    var newVal = parseInt(inputQnty.val(), 10);
                    var step = parseInt(inputQnty.attr("data-step"), 10) || 1;
                    var maxVal = parseInt(inputQnty.attr("max"), 10);

                    if (isNaN(newVal)) newVal = previousVal;
                    if (newVal < 0) newVal = 0;
                    if (!isNaN(maxVal) && maxVal >= 0) newVal = Math.min(newVal, maxVal);
                    if (newVal > 0 && step > 1) {
                        newVal = Math.floor(newVal / step) * step;
                        if (newVal === 0 && (isNaN(maxVal) || maxVal >= step)) newVal = step;
                    }

                    inputQnty.val(newVal);
                    if (newVal === 0) {
                        window.location.href = inputQnty.closest(".cart-row").find(".btn-remove").attr("href");
                        return;
                    }
                    if (newVal === previousVal) return;

                    PriceUpdate(inputQnty);
                    inputQnty.attr("value", newVal);
                    updateCart(id, newVal, false, inputQnty);
                });

            $(".quantity-plus, .quantity-minus").click(function(e) {
                    e.stopPropagation();
                    var classList = $(this).attr("class");

                    //Página de Produto
                    if ($(".mx-auto").length > 0 && $(".cartPage").length == 0) {
                        var step = parseInt($(".input-qty")
                            .attr("step"));
                        var val = parseInt($(".input-qty")
                            .val());
                        if (classList.includes("quantity-plus")) {
                            var max = parseInt($(".input-qty")
                                .attr("max"));
                            if (max > 0) {
                                if ((val + step) <= max) {
                                    $(".input-qty")
                                        .val(step + val)
                                }
                            } else {
                                $(".input-qty")
                                    .val(step + val)
                            }
                        } else {
                            var min = parseInt($(".input-qty")
                                .attr("min"));
                            if (min >= 0) {
                                if ((val - step) >= min) {
                                    $(".input-qty")
                                        .val(val - step)
                                }
                            } else {
                                $(".input-qty")
                                    .val(val - step)
                            }
                        }
                    }
                    //Página de Carrinho
                    else if ($(".cartPage").length > 0) {
                        e.preventDefault();
                        var inputQnty = $(this).closest(".input-spinner").find(".cart_input_qnty");
                        if (!inputQnty.length) return;

                        var step = parseInt(inputQnty.attr("data-step"), 10) || 1;
                        var currentVal = parseInt(inputQnty.val(), 10) || 0;
                        var maxQnty = parseInt(inputQnty.attr("max"), 10);
                        var newVal = currentVal + (classList.includes("quantity-plus") ? step : -step);
                        if (!isNaN(maxQnty) && newVal > maxQnty) {
                            showSaleLimitNotice(maxQnty);
                            return;
                        }
                        if (newVal < 0) return;

                        inputQnty.data("incmUserChange", true).val(newVal).trigger("change");
                    }
                });
        }

        function updateCart(id, qty, redirect, inputQnty) {
  var item = {};
  item.id = id;
  item.quantity = qty;

  if (inputQnty) {
    var maxQnty = parseInt($(inputQnty).attr("max"), 10);

    if (item.quantity >= maxQnty && maxQnty > 0) {
      $(inputQnty).parent().find(".qtyplus").addClass("d-none");
    } else {
      $(inputQnty).parent().find(".qtyplus").removeClass("d-none");
    }
  }

  storeRequestedQty(id, qty);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: item,
    dataType: "json",
    success: function () {
      if (redirect) {
        $.getJSON("/cart.js", function (cart) {
          if (
            window.INCMMiniCartAjax &&
            typeof window.INCMMiniCartAjax.refresh === "function"
          ) {
            window.INCMMiniCartAjax.refresh(cart);
          }
        });
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log("Erro lançado:", errorThrown);
      console.log("Resposta completa (jqXHR):", jqXHR);
    }
  });
}

function addToCart(id, qty, redirect) {
  var item = {};
  item.id = id;
  item.quantity = qty;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: item,
    dataType: "json",
    success: function () {
      if (redirect) {
        $.getJSON("/cart.js", function (cart) {
          if (
            window.INCMMiniCartAjax &&
            typeof window.INCMMiniCartAjax.refresh === "function"
          ) {
            window.INCMMiniCartAjax.refresh(cart);
          }
        });
      }
    },
    error: function () {}
  });
}

        function QuantityCheck(target) {
            if ($(target)
                .attr("data-step") != undefined && $(target)
                .attr("data-step") > 1) {
                var value = $(target)
                    .val();
                var step = $(target)
                    .attr("data-step");
                if (value % step != 0) {
                    if ($(target)
                        .attr("old_value") != undefined) {
                        $(target)
                            .val($(target)
                                .attr("old_value"));
                    } else {
                        $(target)
                            .val($(target)
                                .attr("value"));
                    }
                } else {
                    $(target)
                        .attr("old_value", value);
                }
            }
        }

        var initialCartTotal = parseInt($("#CartFormPage .summaryPrice").first().attr("data-price"), 10);
        var cartTotalAdjustment = isNaN(initialCartTotal) ? 0 : initialCartTotal - sumCartLineTotals();

        function PriceUpdate(inputQnty) {
            var val = parseInt(inputQnty.val(), 10) || 0;
            var unitPrice = parseInt(inputQnty.attr("data-unprice"), 10) || 0;
            inputQnty.closest(".cart-row").find(".rowPrice > span").first()
                .text(formatPrice(val * unitPrice));

            var totalCents = totalPrice();
            $("#CartFormPage .summaryPrice")
                .attr("data-price", totalCents)
                .text(formatPrice(totalCents));
            $(".total.title.cartCost")
                .attr("data-price", totalCents)
                .text(formatPrice(totalCents));
            $(".count.cartCount")
                .text(itemsOnCartCount());
        }

        function formatPrice(priceInCents) {
            var cents = Math.max(0, Math.round(Number(priceInCents) || 0));
            var euros = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return "€" + euros + "," + ("0" + (cents % 100)).slice(-2);
        }

        function itemsOnCartCount() {
            var total = 0;
            $("#CartFormPage .cart_input_qnty")
                .each(function() {
                    total += parseInt($(this).val(), 10) || 0;
                })
            return total;
        }

        function sumCartLineTotals() {
            var total = 0;
            $("#CartFormPage .cart_input_qnty")
                .each(function() {
                    var quantity = parseInt($(this).val(), 10) || 0;
                    var unitPrice = parseInt($(this).attr("data-unprice"), 10) || 0;
                    total += quantity * unitPrice;
                });
            return total;
        }

        function totalPrice() {
            return Math.max(0, sumCartLineTotals() + cartTotalAdjustment);
        }

        VerfiyWindowSize();
        old_cart_B2B_clientes();
        

        /* REMOÇÃO DE LINK INDESEJADO NA JANELA DE COOKIE CONSENT*/
        var cookiebotdetector = setInterval(function() {


            if (getCookie("CookieConsent")) {
                clearInterval(cookiebotdetector)

            }
            if ($("#CybotCookiebotDialogDetailFooter")
                .length) {
                $('#CybotCookiebotDialog')
                    .appendTo(document.body);
                $("#CybotCookiebotDialogDetailFooter")
                    .remove()
                $("#CybotCookiebotDialogDetailBodyContentTextAbout br")
                    .remove()
                $("#CybotCookiebotDialogDetailTableNecessary")
                    .prepend('<caption class="hidden">Janela de Cookies</caption>')
                $("#CybotCookiebotDialogDetailTablePreference")
                    .prepend('<thead><th></th></thead>')
                $("#CybotCookiebotDialogDetailTablePreference")
                    .prepend('<caption class="hidden">Preferências</caption>')

                $("#CybotCookiebotDialogDetailTableStatistics")
                    .prepend('<caption class="hidden">Estatísticas</caption>')
                $("#CybotCookiebotDialogDetailTableAdvertising")
                    .prepend('<caption class="hidden">Publicidade</caption>')
                $("#CybotCookiebotDialogDetailTableUnclassified")
                    .prepend('<caption class="hidden">Sem Classificação</caption>')

                /*
                var tdcontent= $("#CybotCookiebotDialogDetailTablePreference .CybotCookiebotDialogDetailBodyContentCookieTypeTableEmpty").html();
                $("#CybotCookiebotDialogDetailTablePreference .CybotCookiebotDialogDetailBodyContentCookieTypeTableEmpty").parent().append('<th class="CybotCookiebotDialogDetailBodyContentCookieTypeTableEmpty">'+tdcontent+'</th>')
                $("#CybotCookiebotDialogDetailTablePreference td.CybotCookiebotDialogDetailBodyContentCookieTypeTableEmpty").remove()
                */
                clearInterval(cookiebotdetector)
            }

        }, 100)


        if (window.location.pathname.includes("/account/login") && window.location.href.includes("checkout_url")) {
           
            var search = window.location.search.split("=");
            search = decodeURIComponent(search[1]);
          
            if (search.includes("checkout")) {
                sessionStorage.setItem("recoverCheckout", search);
            }

        }


        if ($(".template-product")
            .length > 0) {

            if (window.location.pathname.includes("livro-de-reclamacoes-actividade-privada") && sessionStorage.getItem("infoLivroReclamacao") != undefined) {

                var info = JSON.parse(sessionStorage.getItem("infoLivroReclamacao"));

             
                $("input[name='properties[Nome]']")
                    .val(info.properties["name"]);
                if (info.properties["name2"] != undefined) {
                    $("input[name='properties[Nome2]']")
                        .val(info.properties["name2"]);
                }

                $("input[name='properties[Morada]']")
                    .val(info.properties["address"]);
                $("input[name='properties[Localidade]']")
                    .val(info.properties["city"]);
                $("input[name='properties[CodPostal]']")
                    .val(info.properties["postal"]);
                $("input[name='properties[NIF]']")
                    .val(info.properties["nif"]);
                $("input[name='properties[CAE]']")
                    .val(info.properties["cae"]);
                $(".checkInputs input")
                    .attr("readonly", true);


            }
        }




        GetCurrentLang();
        if (window.location.pathname == "/account") {

            var customer_id = $(".change_nif .customer_id")[0].innerText;

            $(".btn_new_nif")
                .click(function() {


                    var new_nif = $(".change_nif .input_nif")
                        .val();
                    var country = $("#countryNIF")
                        .val();

                    //DESCOMENTAR QUANDO FOR PARA USAR O VERIFY_NIF
                    //FUNÇÃO QUE VERIFICA SE O NIF É VALIDO
                    VerifyNif(new_nif, country);
                    //https://incm.bydascloud.com/?action=validate_nif&nif=209174285&country=PT
                    /*$.post( ENDPOINT, { action:"update_nif", client_id: customer_id, nif:new_nif })
                       .done(function( data ) {
                       	data = JSON.parse(data);
          				// stauts 0 -> erro // status 1 -> ja existe e é igual // status 2 -> criado/update
                        if(data.status == 0){
							$(".responses_update .error_update").removeClass("d-none")
                            $(".responses_update .error_update").addClass("d-block")
                        }else if(data.status == 1){
                        	$(".responses_update .same_nif").removeClass("d-none")
                            $(".responses_update .same_nif").addClass("d-block")
                        }else if(data.status == 2){
                        	$("responses_update .ok_update").removeClass("d-none")
                            $(".responses_update .ok_update").addClass("d-block")
                        }
  		})*/


                })
        }

        if (sessionStorage.getItem("autoCart") != undefined) {
  
            var cookieAutoCart = sessionStorage.getItem("autoCart");
            $.get("/cart.js")
                .then((cart) => {

                    cart = JSON.parse(cart);

                    if (cart.items.length == 0) {
                        clearCookies();
                    }

                    var removeCookies = true;
                    cart.items.forEach((item) => {
                        if (cookieAutoCart.includes(item.variant_id)) {
                            removeCookies = false;
                        }

                    })

                    if (removeCookies == true) {
                        clearCookies();
                    }

                })
                .fail((error) => {

                   

                })

        }


        if (window.location.pathname == "/cart") {

            if (sessionStorage.getItem("recoverCheckout") != undefined) {

                var url = sessionStorage.getItem("recoverCheckout");
                sessionStorage.removeItem("recoverCheckout");
                /*
                LUIS
                console.log(url)
                return false;
                */
                //window.location.href = url;

            }


            $(".product form[action='/cart/add'] button[type='submit']")
                .click(function(e) {

                    e.preventDefault();
                    e.stopPropagation();
                    $(this)
                        .parents("form[action='/cart/add']")
                        .submit();
                    $('.cart.main-content')
                        .load(window.location.href + " .cart.main-content > *")

                })

            var RemoveCookie = false;
         
            var cookieAutoCart = sessionStorage.getItem("autoCart");
            if (cookieAutoCart != undefined) {

                cookieAutoCart = cookieAutoCart.split(",");
      
                $(cookieAutoCart)
                    .each((key, value) => {

                        if ($(".cart__meta[data-id=" + value + "]")
                            .length == 0) {
                            cookieAutoCart.splice(key, 1);
                        }

                    })

                cookieAutoCart = cookieAutoCart.join(",");


                if (($("#CartFormPage .table-cart .cart-row")
                        .length == 0 && (sessionStorage.getItem("autoCart") != undefined || sessionStorage.getItem("infoLivroReclamacao") != undefined)) || cookieAutoCart == "") {
                    RemoveCookie = true;
                }

            }

            for (var i = 0; i < $("#CartFormPage .table-cart .cart-row")
                .length; i++) {

                var variant_id = $($("#CartFormPage .table .cart-row .quantity input")[i])
                    .attr("id");
                variant_id = variant_id.replace("updates_", "");
                variant_id = variant_id.split(":");
                variant_id = variant_id[0];

                var qnt_value = parseInt($($("#CartFormPage .table .cart-row .quantity input")[i])
                    .attr("value"))
                var qnt_max_value = parseInt($($("#CartFormPage .table .cart-row .quantity input")[i])
                    .attr("max"))


                if (cookieAutoCart != undefined && cookieAutoCart.includes(variant_id) == true) {
                    $($("#CartFormPage .table .cart-row .cart-product-quantity")[i])
                        .removeClass("d-none");
                    $($("#CartFormPage .table .cart-row .quantity input")[i])
                        .attr("readonly", true);
                    $($("#CartFormPage .table .cart-row .quantity input")[i])
                        .parent()
                        .find(".input-group-append")
                        .remove();
                    $($("#CartFormPage .table .cart-row .quantity input")[i])
                        .parent()
                        .find(".input-group-prepend")
                        .remove();
                }


                if (qnt_value > qnt_max_value && (cookieAutoCart == undefined || cookieAutoCart.includes(variant_id) == false)) {

                    $("#CartFormPage .table .cart-row .quantity input")[i].value = qnt_max_value;
                }

            }

            if (RemoveCookie == true) {
                clearCookies();
            }

            //console.log(window.location);
            if (window.location.search.includes("?auto=")) {
                autoCartAddProduct();
            }
        }

        if ($(".checkInputs input")
            .length > 0) {

            $(".checkInputs input")
                .keyup(function() {

                    var val = $(this).val();
               
                    if (val.match(/[a-z]/i) == null) {

                        $(this).val(val.trim())

                    }

                    //

                })

            $("#AddToCart-product-template2")
                .click(function(e) {

                    //e.preventDefault();

                    $(".checkInputs input")
                        .each(function() {

                            var val = $(this)
                                .val();

                            if (val != "") {
                                $(this)
                                    .val(val.trim());
                            }


                        })


                    //$(".template-product form[action='/cart/add']#cart-form--product-template2 #AddToCart-product-template2").click();

                })


        }

        $(".address-new-toggle")
            .click(function() {

                $("#AddressNewForm")
                    .removeClass("d-none");

            })


        $(".address-new-toggle.btn_cancel")
            .click(function() {

                $("#AddressNewForm")
                    .addClass("d-none");

            })

        $(".address-edit-toggle")
            .click(function() {

                var id = $(this).attr("data-form-id");
              

                $("#EditAddress_" + id).removeClass("d-none");

            })

        $(".address-edit-toggle.btn_cancel")
            .click(function() {

                var id = $(this)
                    .attr("data-form-id");

                $("#EditAddress_" + id)
                    .addClass("d-none");

            })

        $('.address-delete')
            .on('click', function() {
                var $el = $(this);
                var formId = $el.data('form-id');
                var confirmMessage = $el.data('confirm-message');

                // eslint-disable-next-line no-alert
                if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                    Shopify.postLink('/account/addresses/' + formId, {
                        parameters: {
                            _method: 'delete'
                        }
                    });
                }
            });

        /*if($(".collection-products .kt_layerfilterGroups").length > 0){
  	
    var filter_facial = $(".collection-products .kt_layerfilterGroups .kt_filterGroupItem")[2];

    $(filter_facial).find("li").each(function(){
      var innerText = $(this).find("span")[0].innerText;
      innerText = innerText.replaceAll(".", ",")
      
       $(this).find("span")[0].innerText = innerText;
	})
  }*/

        $(".collection-products .filter-by")
            .click(function() {

                $(".sortbyAndLayout div")
                    .removeClass('show')
            })


        /*--------------------------------------------
           Modal ViewExcerpt
          ---------------------------------------------*/
        var modal_background = document.getElementById("modal_pdf");
        var modal = document.getElementById("modal_excerpt");



        $('#excerpt')
            .click(function() {
                $(modal_background)
                    .css("display", "block");
                $(modal)
                    .css("display", "block");
                $("html")
                    .css("overflow", "hidden");

            });

        $('.close_modal_excerpt')
            .click(function() {
                $(modal_background)
                    .css("display", "none");
                $(modal)
                    .css("display", "none");
                $("html")
                    .css("overflow", "auto");
            });

        /*--------------------------------------------
           Modal View3D
          ---------------------------------------------*/
        var modal3d_background = document.getElementById("modal_3d_background");
        var modal3d = document.getElementById("modal_3d");


        $('#model_3d')
            .click(function() {
                
                $(modal3d_background)
                    .css("display", "block");
                $(modal3d)
                    .css("display", "block");
                $("html")
                    .css("overflow", "hidden");

            });

        $('.close_modal_3d')
            .click(function() {
                $(modal3d_background)
                    .css("display", "none");
                $(modal3d)
                    .css("display", "none");
                $("html")
                    .css("overflow", "auto");
            });

        /*--------------------------------------------
          Modal Product Video
         ---------------------------------------------*/

        var prod_video_background = document.getElementById("product_video_background");
        var prod_video = document.getElementById("product_video");

        $(".product-single__media")
            .click(function() {
                $(prod_video_background)
                    .css("display", "block");
                $(prod_video)
                    .css("display", "block");
                $("html")
                    .css("overflow", "hidden");
            });

        $('.close_video')
            .click(function() {
                $(prod_video_background)
                    .css("display", "none");
                $(prod_video)
                    .css("display", "none");
                $("html")
                    .css("overflow", "auto");
            });



        if ($("#modal-activate")
            .length > 0) {

            var homepage_url = $("#modal-activate .homepage_url")[0].innerHTML;
            if (homepage_url == "pt-PT") {
                homepage_url = "pt";
            } else {
                homepage_url = "en";
            }

            $(".login-page .content_newsite .open_modal_recover")
                .click(function() {

                    $("#modal-activate")
                        .css("display", "block");

                });

            $("#modal-activate .modal-activate-close")
                .click(function() {
                    $("#modal-activate")
                        .css("display", "none");
                });

            $("#modal-activate .btn_recover")
                .click(function(e) {

                    var email = $("#modal-activate input")
                        .val();


                    $.get("https://incm.bydascloud.com/?action=resend-invite&store="+STORE+"&lang=" + homepage_url, {
                            action: "resend-invite",
                            email: email
                        }, function(data) {

                        })
                        .done(function(data) {

                            data = $.parseJSON(data);

                            if (data.status == 1) {
                                var html = '<label class="message">' + data.msg + '</label>';
                                $("#modal-activate .modal-activate-container")
                                    .prepend(html);
                            } else {
                                var html = '<label class="message">' + data.msg + '</label>';
                                $("#modal-activate .modal-activate-container")
                                    .prepend(html);
                                return data;

                            }
                        })
                        .fail(function() {
                            return false;
                        })

                })

        }

        if ($(".template-product")
            .length > 0) {

            if ($(".More__info")
                .length > 0) {

                $("#AddToCart-product-template2")
                    .click(function(e) {

                        //e.preventDefault();

                        if ($("#qty-product-template2")
                            .val() > 1) {
                            
                            var launch = true;
                            $("form#cart-form--product-template2 .checkInputs input[required]")
                                .each((key, item) => {
                                    if ($(item)
                                        .val() == "") {
                                        launch = false;
                                    }
                                })

                           
                            e.preventDefault();
                            if (launch) {
                                if ($('input[name="properties[consent]"]')
                                    .length == 0) {
                                    e.preventDefault();
                                    $(".popup_livro_reclamacao_quantity")
                                        .removeClass("d-none");
                                    $(".popup_livro_reclamacao_quantity")
                                        .show();
                                }
                            }
                        }


                        // $(".template-product form[action='/cart/add']#cart-form--product-template2 #AddToCart-product-template2").click();

                    })

                $(".popup_livro_reclamacao_quantity .close_")
                    .click(function() {

                        $(".popup_livro_reclamacao_quantity")
                            .addClass("d-none");
                        $(".popup_livro_reclamacao_quantity")
                            .hide();

                    })

                $(".popup_livro_reclamacao_quantity .accepet")
                    .click(function() {
                        var inputHidden = `<input type="hidden" name="properties[consent]" value="agree">`;
                        $("form#cart-form--product-template2 .checkInputs")
                            .append(inputHidden);

                        $(".popup_livro_reclamacao_quantity")
                            .addClass("d-none");

                        $(".popup_livro_reclamacao_quantity")
                            .hide();
                      
                        $("form#cart-form--product-template2")
                            .submit();
                        //window.location.pathname="/cart";
                    })

            }
        }


        if ($(".form-footer .homepage_url")
            .length > 0) {
            var lang = $(".form-footer .homepage_url")[0].innerHTML;
            if (lang == "pt-PT") {
                var registo_sessao = "Por favor, inicie sessão";
                var registo_sessao_link = "aqui";
                var error_server = "Não foi possível ligar ao servidor para registar nova conta. Tente novamente!";
                var error_terms = "Tem que aceitar os Termos e Condições para criar a sua conta";
                lang = "pt";
            } else {
                lang = "en";
                var registo_sessao = "Please log in";
                var registo_sessao_link = "here";
                var error_server = "Could not connect to the server to register a new account. Try again!";
                var error_terms = "You must accept the Terms and Conditions to create your account";
            }
        }

        // Quando o cliente veio do fluxo de complemento, abrir o separador Registo.
        if (new URLSearchParams(window.location.search).get("complete") === "1") {
            $("#register-tab").tab("show");
            $("#CustomerRegisterForm .feedback")
                .html(lang === "en"
                    ? "Complete the missing details of your existing account."
                    : "Complete os dados em falta da sua conta existente.")
                .css({color: "#856404", border: "1px solid #ffeeba", backgroundColor: "#fff3cd"})
                .show();
        }

        // Quando o cliente veio do fluxo de complemento, manter o email da conta
        // original e enviar o customer_id para o endpoint fazer PUT, não POST.
        if (new URLSearchParams(window.location.search).get("complete") === "1") {
            var profileEmail = sessionStorage.getItem("customer_profile_email");
            if (profileEmail) {
                $("#register-email").val(profileEmail).prop("readonly", true);
            }
        }

        $("#CustomerRegisterForm button[type=button]").click(function() {

          
          $("#CustomerRegisterForm").find('input:not([type="hidden"])').each(function() {
              if($(this).val() === ''){
                $(this).css('border', '2px solid red');
              }else{
                $(this).css('border', '1px solid #ebebeb');
              }
          });
          
          if ($(".termos_checkbox").is(":checked") && $(".termos_dados_checkbox").is(":checked")) {
              $("#CustomerRegisterForm button[type=button]")
                  .prop("disabled", true)
              $("#CustomerRegisterForm button[type=button]")
                  .prepend('<i class="fa fa-spinner fa-spin"></i>');
      
              var first_name = $("#first_name")
                  .val();
              var last_name = $("#last_name")
                  .val();
              var birthday = $("#birthday")
                  .val();
              var email = $("#register-email")
                  .val();
              var phone = $("#phone")
                  .val();
              var password = $("#register-password")
                  .val();
              var vat = $("#NIF")
                  .val()
              var address = $("#address")
                  .val()
              var address2 = $("#address2")
                  .val()
              var city = $("#city")
                  .val()
              var zip = $("#zip")
                  .val()
              var country = $("#country")
                  .val()
              if ($("#customer_card")
                  .is(":checked")) {
                  var customer_card = 1;
              } else {
                  var customer_card = 0;
              }
              // MUDADO PARA marketing dia 06/09/2021 para que na criação de clientes seja listado para receber newsletter.
              if ($("#marketing")
                  .is(":checked")) {
                  var marketing = 1;
              } else {
                  var marketing = 0;
              }
      
              if (!subF()) {
                
                  $(".feedback")
                      .html(errPm + window.va)
                      .show();
                  $("html, body")
                      .stop()
                      .animate({
                          scrollTop: 0
                      }, 500, 'swing');
                  $("#CustomerRegisterForm button[type=button]")
                      .prop("disabled", false);
                  return false;
              }
      
              if (password.length >= 10) {
                  var username = email.split("@")[0].toLowerCase();
                  if (password.toLowerCase() != username) {
                      var temMaiuscula = false;
                      var temMinuscula = false;
                      var temDigito = false;
                      var temCaraterEspecial = false;
                      var temCaraterSeguidoIgual = false;
                      var lowChar = "";
                      var uppChar = "";
                      var prevChar = "";
                      var specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
                      var charChecked = false;
      
                      for (var i = 0; i < password.length; i++) {
                          charChecked = false;
      
                          if (i > 0) {
                              prevChar = password[i - 1];
                              if (password[i] == prevChar) {
                                  temCaraterSeguidoIgual = true;
                                  break;
                              }
                          }
      
                          if (temCaraterSeguidoIgual == false) {
                              if (charChecked == false && temCaraterEspecial == false && specialChar.test(password[i])) {
                                  temCaraterEspecial = true;
                                  charChecked = true;
                              } 
                            
                              if (charChecked == false && temDigito == false && isNumeric(password[i])) {
                                  temDigito = true;
                                  charChecked = true;
                              } 
                            
                              if (charChecked == false && temMaiuscula == false && !isNumeric(password[i])) {
                                  uppChar = password[i].toUpperCase();
                                  if (password[i] == uppChar) {
                                      temMaiuscula = true;
                                      charChecked = true;
                                  }
                              }
                            
                              if (charChecked == false && temMinuscula == false && !isNumeric(password[i])) {
                                  lowChar = password[i].toLowerCase();
                                  if (password[i] == lowChar) {
                                      temMinuscula = true;
                                      charChecked = true;
                                  }
                              }
                          }
                      }
      
                      if (temCaraterEspecial && temDigito && temMaiuscula && temMinuscula) {
                          $.post(ENDPOINT, {
                                  action: "create_customer",
                                  store: STORE,
                                  first_name,
                                  last_name,
                                  birthday,
                                  email,
                                  phone,
                                  password,
                                  vat,
                                  address,
                                  address2,
                                  city,
                                  zip,
                                  country,
                                   customer_card,
                                   customer_id: new URLSearchParams(window.location.search).get("customer_id") || sessionStorage.getItem("customer_profile_id") || "",
                                   marketing,
                                   lang
                              })
                              .done(function(data) {
      
                                  data = JSON.parse(data)
      
                                   if (data.status == 1) {
                                       sessionStorage.removeItem("customer_profile_id");
                                       sessionStorage.removeItem("customer_profile_email");
                                       if (window.location.pathname.includes("/en/")) {
      
                                          var url = "/en/account/login"
      
                                      } else {
      
                                          var url = "/account/login"
      
      
                                      }
                                      $("#CustomerRegisterForm")
                                          .html('<div class="feedback-success" style="margin:20px 0px;color:#2bb673;text-align:center;border:1px solid #2bb673;padding:10px;background-color:#e4f4ec">' + data.msg + '. ' + registo_sessao + ' <a href="' + url + '"><strong>' + registo_sessao_link + '</strong></a></div>');
                                      $("html, body")
                                          .stop()
                                          .animate({
                                              scrollTop: 0
                                          }, 500, 'swing')
                                  } else {
                                      $(".feedback")
                                          .html(data.msg) //problema
                                          .show();
                                      $("html, body")
                                          .stop()
                                          .animate({
                                              scrollTop: 0
                                          }, 500, 'swing')
                                      $("#CustomerRegisterForm button[type=button]")
                                          .prop("disabled", false)
                                      $("#CustomerRegisterForm button[type=button] i")
                                          .remove();
                                  }
                              })
                              .fail(function(data) {
                                  
                                  $("#CustomerRegisterForm button[type=button]")
                                      .prop("disabled", false)
                                  $("#CustomerRegisterForm button[type=button] i")
                                      .remove();
                                  $(".feedback")
                                      .html("Erro de ligação. Tente novamente!")
                                      .show();
                                  $("html, body")
                                      .stop()
                                      .animate({
                                          scrollTop: 0
                                      }, 500, 'swing')
                              })
                      } 
                      else {
      
                          $("#CustomerRegisterForm button[type=button]")
                              .prop("disabled", false)
                          $("#CustomerRegisterForm button[type=button] i")
                              .remove();
                          if (temCaraterSeguidoIgual) {
                              $(".feedback")
                                  .html("Por favor certifique-se que a sua password não contém caracters iguais seguidos.")
                                  .show();
                          } else {
                              $(".feedback")
                                  .html("Por favor certifique-se que a sua password contém pelo menos uma letra maiúscula, uma letra minúscula, um dígito e um caracter especial.")
                                  .show();
                          }
                          $("html, body")
                              .stop()
                              .animate({
                                  scrollTop: 0
                              }, 500, 'swing')
                      }
                  } else {
                      $("#CustomerRegisterForm button[type=button]")
                          .prop("disabled", false)
                      $("#CustomerRegisterForm button[type=button] i")
                          .remove();
                      $(".feedback")
                          .html("Por favor certifique-se que a sua password é diferente do seu email.")
                          .show();
                      $("html, body")
                          .stop()
                          .animate({
                              scrollTop: 0
                          }, 500, 'swing')
                  }
              } else {
                  $("#CustomerRegisterForm button[type=button]")
                      .prop("disabled", false)
                  $("#CustomerRegisterForm button[type=button] i")
                      .remove();
                  $(".feedback")
                      .html("Por favor certifique-se que a sua password tem um tamanho mínimo de 10 caracters.")
                      .show();
                  $("html, body")
                      .stop()
                      .animate({
                          scrollTop: 0
                      }, 500, 'swing')
              }
          } else {
              $(".feedback")
                  .html("Por favor preencha os campos obrigatórios")
                  .show();
              $("html, body")
                  .stop()
                  .animate({
                      scrollTop: 0
                  }, 500, 'swing')
          }
      
      })


        function GetCurrentLang() {

            var lang = window.localStorage.getItem("translation-lab-lang");

            if (lang != undefined && lang != "") {

                $("body")
                    .addClass(lang);
                if (lang == "en") {

                    $(".kt_home_slide .pt-pt")
                        .remove();

                } else {

                    $(".kt_home_slide .en")
                        .remove();

                }

            } else {
                $(".kt_home_slide .en")
                    .remove();
            }

        }

      $(".form_submit_div.text-center .btn").click(function(){

        var counter = 0;
        var hasErrors = setInterval(function(){if($(".alert.alert-danger").length>0){ clearInterval(hasErrors)} else { counter+=50} if(counter>2000){clearInterval(hasErrors)}},50)
     
        if($(".alert.alert-danger").length>0){
          var mensagensErro = $(".alert.alert-danger")[0].innerText.split("\n");
    
          var originalHTML = $(".alert.alert-danger")[0].innerHTML.split("</button>")[0] + "</button>";
          var email = "";
          var msg = "";
      
          for(var i = 0; i < mensagensErro.length; i++){
            if(mensagensErro[i] == 'Endereço de Email is required'){
              email = "O endereço de email é obrigatório";
              originalHTML += email;
            } 
            if(mensagensErro[i] == 'A sua Mensagem is required'){
              msg = "<br>É necessário preencher uma mensagem";
              originalHTML += msg;
            }
          }
    
          $(".alert.alert-danger")[0].innerHTML = originalHTML;
        }
       })

    })

    function onlyNumberKey(evt) {
              
            // Only ASCII character in that range allowed
            var ASCIICode = (evt.which) ? evt.which : evt.keyCode
            if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
                return false;
            return true;
        }

function isCartCorrectionConfirmed(cart, correction) {
    var matchingItems = (cart.items || []).filter(function(item) {
        if (correction.key) return String(item.key || "") === correction.key;
        return String(item.sku || "") === correction.sku &&
            (!correction.variantId || String(item.variant_id || item.id || "") === correction.variantId);
    });
    if (correction.quantity === 0) return matchingItems.length === 0;
    return matchingItems.length === 1 && Number(matchingItems[0].quantity) === correction.quantity;
}

function showSaleLimitNotice(limit) {
    $(".limit_sale_message").text("Não pode adicionar mais de " + limit + " unidades deste produto.");
    $(".update_cart_timeout").attr("role", "alert").attr("aria-live", "polite").css("display", "block");
}

$(document).on("input change keyup", '#CartFormPage input[name="updates[]"][max]', function(event) {
    if (!event.originalEvent || event.originalEvent.isTrusted === false) {
        return;
    }

    var quantityInput = $(this),
        qntValue = parseInt(quantityInput.val(), 10),
        qntMaxValue = parseInt(quantityInput.attr("max"), 10);

    $("#update-cart").prop("disabled", false).removeAttr("disabled").show();

    if (isNaN(qntValue) || isNaN(qntMaxValue) || qntValue <= qntMaxValue) {
        return;
    }

    quantityInput.val(qntMaxValue);
    $("#irregular-checkout").remove();
    showSaleLimitNotice(qntMaxValue);
});

var invC = false;
var errPm,
    checkout_lang = 'pt';
switch (checkout_lang) {
    case 'pt':
        errPm = "O código postal está incorrecto. O formato correcto para o seu país é ";
        break;
    case 'es':
        errPm = "El código postal es incorrecto. El formato para su país es ";
        break;
    case 'fr':
        errPm = "Le code postal est incorrect. Le format de votre pays est ";
        break;
    default:
        errPm = "The postal code is incorrect. The format for your country is ";
}

function getPPD(e) {
    window.lastPPL = false;
    var cEl = document.querySelector('#country'),
        zEl = document.querySelector('#zip');


    if (cEl.value == "Greece" && zEl.value && zEl.value.length == 3) {
        zEl.value += " ";
        window.lastPPL = true;
    }

}

function isNumeric(value) {
    return /^\d+$/.test(value);
}

function getPPU(e) {
    var cEl = document.querySelector('#country'),
        zEl = document.querySelector('#zip');

    if (cEl.value == "Greece" && zEl.value && zEl.value.length == 4 && !window.lastPPL)
        zEl.value = zEl.value.substring(0, 2);


}

function getPP() {
    var cEl = document.querySelector('#country'),
        zEl = document.querySelector('#zip'),
        bSub = document.querySelector('form button[type="submit"]');
    if (!zEl.value || !zEl.value.trim()) {
        zEl.style.border = "1px solid #d5d5d5";
        bSub.style.background = "#000000";
        return true;
    }
    if (!getP(cEl.options[cEl.selectedIndex].value, zEl.value.trim())) {
        zEl.style.border = "1px solid red";
        bSub.style.background = "#cccccc";
        invC = true;
    } else {
        if (window.document.querySelector('#country_zip_c'))
            window.document.querySelector('#country_zip_c')
            .remove();

        zEl.style.border = "1px solid #d5d5d5";
        bSub.style.background = "#000000";
        invC = false;
    }
}

function getP(co, ps) {
    var cf = false;
    for (var i = 0; i < cpr.length; i++) {
        if (co.toUpperCase() == cpr[i].code) {
            window.va = cpr[i].zip;
            if (defP(cpr[i].zip, ps)) return true;
            cf = true;
        }

    }

    if (!cf) return true;

    return false;

}

function subF() {
    getPP();
    if (invC)
        return false;
    return true;
}

function defP(pf, pc) {
    if (!pc) return false;
    var dc = false;
    pc = pc.toUpperCase();
    for (var i = 0; i < pf.length; i++) {
        if (pf.length != pc.length) return false;
        if (pf[i].match(/[0-9]/i)) {
            if (!pc[i].match(/[0-9]/i))
                return false;
            dc = true;
        }
        if (pf[i].match(/[a-z]/i)) {
            if (!pc[i].match(/[a-z]/i))
                return false;
            dc = true;
        }
        if (pf[i].match(/[ ]/i)) {
            if (!pc[i].match(/[ ]/i))
                return false;
            dc = true;
        }
        if (pf[i].match(/[-]/i)) {
            if (!pc[i].match(/[-]/i))
                return false;
            dc = true;
        }
    }
    return dc;
}

var cpr = [{
    "code": "AD",
    "zip": "AA999",
    "cn": 5
}, {
    "code": "AM",
    "zip": "9999",
    "cn": 4
}, {
    "code": "AR",
    "zip": "9999",
    "cn": 4
}, {
    "code": "AS",
    "zip": "99999",
    "cn": 5
}, {
    "code": "AT",
    "zip": "9999",
    "cn": 4
}, {
    "code": "AU",
    "zip": "9999",
    "cn": 4
}, {
    "code": "AZ",
    "zip": "999999",
    "cn": 6
}, {
    "code": "AZ",
    "zip": "9999",
    "cn": 4
}, {
    "code": "BA",
    "zip": "99999",
    "cn": 5
}, {
    "code": "BD",
    "zip": "9999",
    "cn": 4
}, {
    "code": "BE",
    "zip": "9999",
    "cn": 4
}, {
    "code": "BG",
    "zip": "9999",
    "cn": 4
}, {
    "code": "BN",
    "zip": "AA9999",
    "cn": 6
}, {
    "code": "BR",
    "zip": "99999",
    "cn": 5
}, {
    "code": "BR",
    "zip": "99999-999",
    "cn": 5
}, {
    "code": "BR",
    "zip": "99999999",
    "cn": 5
}, {
    "code": "BY",
    "zip": "999999",
    "cn": 6
}, {
    "code": "CA",
    "zip": "A9A 9A",
    "cn": 6
}, {
    "code": "CA",
    "zip": "A9A 9A9",
    "cn": 6
}, {
    "code": "CH",
    "zip": "9999",
    "cn": 4
}, {
    "code": "CN",
    "zip": "999999",
    "cn": 6
}, {
    "code": "CO",
    "zip": "999999",
    "cn": 6
}, {
    "code": "CU",
    "zip": "99999",
    "cn": 5
}, {
    "code": "CY",
    "zip": "9999",
    "cn": 4
}, {
    "code": "CZ",
    "zip": "999 99",
    "cn": 6
}, {
    "code": "DE",
    "zip": "99999",
    "cn": 5
}, {
    "code": "DK",
    "zip": "9999",
    "cn": 4
}, {
    "code": "DZ",
    "zip": "99999",
    "cn": 5
}, {
    "code": "EC",
    "zip": "999999",
    "cn": 6
}, {
    "code": "EE",
    "zip": "99999",
    "cn": 5
}, {
    "code": "ES",
    "zip": "99999",
    "cn": 5
}, {
    "code": "FI",
    "zip": "99999",
    "cn": 5
}, {
    "code": "FM",
    "zip": "99999",
    "cn": 5
}, {
    "code": "FO",
    "zip": "999",
    "cn": 3
}, {
    "code": "FR",
    "zip": "99999",
    "cn": 5
}, {
    "code": "GB",
    "zip": "AA9A 9AA",
    "cn": 6
}, {
    "code": "GB",
    "zip": "A99 9AA",
    "cn": 5
}, {
    "code": "GB",
    "zip": "A9A 9AA",
    "cn": 5
}, {
    "code": "GB",
    "zip": "A9 9AA",
    "cn": 4
}, {
    "code": "GB",
    "zip": "AA99 9AA",
    "cn": 6
}, {
    "code": "GB",
    "zip": "AA9 9AA",
    "cn": 5
}, {
    "code": "GE",
    "zip": "9999",
    "cn": 4
}, {
    "code": "GF",
    "zip": "99999",
    "cn": 5
}, {
    "code": "GG",
    "zip": "AA99 9AA",
    "cn": 4
}, {
    "code": "GG",
    "zip": "AA9 9AA",
    "cn": 3
}, {
    "code": "GL",
    "zip": "9999",
    "cn": 4
}, {
    "code": "GP",
    "zip": "99999",
    "cn": 5
}, {
    "code": "GR",
    "zip": "999 99",
    "cn": 6
}, {
    "code": "GU",
    "zip": "99999",
    "cn": 5
}, {
    "code": "GU",
    "zip": "99999-9999",
    "cn": 5
}, {
    "code": "HR",
    "zip": "99999",
    "cn": 5
}, {
    "code": "HU",
    "zip": "9999",
    "cn": 4
}, {
    "code": "IC",
    "zip": "99999",
    "cn": 5
}, {
    "code": "ID",
    "zip": "99999",
    "cn": 5
}, {
    "code": "IL",
    "zip": "9999999",
    "cn": 7
}, {
    "code": "IN",
    "zip": "999999",
    "cn": 6
}, {
    "code": "IS",
    "zip": "999",
    "cn": 3
}, {
    "code": "IT",
    "zip": "99999",
    "cn": 5
}, {
    "code": "JE",
    "zip": "AA9 9AA",
    "cn": 3
}, {
    "code": "JP",
    "zip": "999-9999",
    "cn": 8
}, {
    "code": "KG",
    "zip": "999999",
    "cn": 6
}, {
    "code": "KH",
    "zip": "99999",
    "cn": 5
}, {
    "code": "KR",
    "zip": "99999",
    "cn": 5
}, {
    "code": "KV",
    "zip": "99999",
    "cn": 5
}, {
    "code": "KZ",
    "zip": "999999",
    "cn": 6
}, {
    "code": "LI",
    "zip": "9999",
    "cn": 4
}, {
    "code": "LT",
    "zip": "99999",
    "cn": 5
}, {
    "code": "LU",
    "zip": "9999",
    "cn": 4
}, {
    "code": "LV",
    "zip": "9999",
    "cn": 4
}, {
    "code": "MA",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MC",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MD",
    "zip": "9999",
    "cn": 4
}, {
    "code": "ME",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MG",
    "zip": "999",
    "cn": 3
}, {
    "code": "MH",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MK",
    "zip": "9999",
    "cn": 4
}, {
    "code": "MN",
    "zip": "999999",
    "cn": 6
}, {
    "code": "MN",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MP",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MQ",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MV",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MV",
    "zip": "9999",
    "cn": 4
}, {
    "code": "MX",
    "zip": "99999",
    "cn": 5
}, {
    "code": "MY",
    "zip": "99999",
    "cn": 5
}, {
    "code": "NC",
    "zip": "99999",
    "cn": 5
}, {
    "code": "NL",
    "zip": "9999",
    "cn": 4
}, {
    "code": "NL",
    "zip": "9999 AA",
    "cn": 4
}, {
    "code": "NO",
    "zip": "9999",
    "cn": 4
}, {
    "code": "NZ",
    "zip": "9999",
    "cn": 4
}, {
    "code": "PG",
    "zip": "999",
    "cn": 3
}, {
    "code": "PH",
    "zip": "9999",
    "cn": 4
}, {
    "code": "PK",
    "zip": "99999",
    "cn": 5
}, {
    "code": "PL",
    "zip": "99-999",
    "cn": 6
}, {
    "code": "PR",
    "zip": "99999",
    "cn": 5
}, {
    "code": "PT",
    "zip": "9999-999",
    "cn": 8
}, {
    "code": "PW",
    "zip": "99999",
    "cn": 5
}, {
    "code": "RE",
    "zip": "99999",
    "cn": 5
}, {
    "code": "RO",
    "zip": "999999",
    "cn": 6
}, {
    "code": "RS",
    "zip": "99999",
    "cn": 5
}, {
    "code": "RU",
    "zip": "999999",
    "cn": 6
}, {
    "code": "SE",
    "zip": "999 99",
    "cn": 6
}, {
    "code": "SG",
    "zip": "999999",
    "cn": 6
}, {
    "code": "SH",
    "zip": "AAAA 9AA",
    "cn": 8
}, {
    "code": "SI",
    "zip": "9999",
    "cn": 4
}, {
    "code": "SK",
    "zip": "999 99",
    "cn": 6
}, {
    "code": "SM",
    "zip": "99999",
    "cn": 5
}, {
    "code": "SZ",
    "zip": "A999",
    "cn": 4
}, {
    "code": "TH",
    "zip": "99999",
    "cn": 5
}, {
    "code": "TN",
    "zip": "9999",
    "cn": 4
}, {
    "code": "TR",
    "zip": "99999",
    "cn": 5
}, {
    "code": "TW",
    "zip": "999",
    "cn": 3
}, {
    "code": "TW",
    "zip": "99999",
    "cn": 5
}, {
    "code": "UA",
    "zip": "99999",
    "cn": 5
}, {
    "code": "US",
    "zip": "99999",
    "cn": 5
}, {
    "code": "US",
    "zip": "99999-9999",
    "cn": 5
}, {
    "code": "UZ",
    "zip": "999999",
    "cn": 6
}, {
    "code": "VI",
    "zip": "99999",
    "cn": 5
}, {
    "code": "XY",
    "zip": "99999",
    "cn": 5
}, {
    "code": "YT",
    "zip": "99999",
    "cn": 5
}, {
    "code": "ZA",
    "zip": "9999",
    "cn": 4
}];


/* CART EXTENSION */

$(document).ready(function() {
        var regularCheckoutButton = document.getElementById("regular-checkout");
        var regularCheckoutAction = null;
        var creditCheckoutUrl = "/discount/Pagamento%20a%20Cr%C3%A9dito.?redirect=/checkout";

        function setRegularCheckoutAction(action) {
            regularCheckoutAction = action;

            var currentRegularCheckoutButton = document.getElementById("regular-checkout");
            if (currentRegularCheckoutButton) {
                currentRegularCheckoutButton.disabled = false;
            }
        }

        if (regularCheckoutButton && regularCheckoutButton.dataset.customerAuthenticated === "true" && $("#cart-extended").length) {
            regularCheckoutButton.disabled = true;
            document.addEventListener("click", function(e) {
                var currentRegularCheckoutButton = e.target.closest ? e.target.closest("#regular-checkout") : null;
                if (!currentRegularCheckoutButton) {
                    return;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                if (typeof regularCheckoutAction === "function") {
                    regularCheckoutAction.call(currentRegularCheckoutButton, e);
                }
            }, true);
        } else {
            $("#regular-checkout").off("click").on("click", function(e) {
                e.preventDefault();
                $("#checkout-form").submit();
            });
        }


        if (window.location.href.includes("/account")) {

            let url = new URL(window.location);
            let To = url.searchParams.get("To");

            if ($("#" + To)
                .length > 0) {

                $("#" + To)
                    .click();
                window.history.replaceState({}, document.title, "/account" + "");

            }



        }


        // INICIO DE CART EXTENDED
  
        if ($("#cart-extended").length) {
   
            var obj = {};
            var b2c_products = new Object();
            var remove_cart = new Object();
            var b2b_products = new Object();
            obj.cart = [];
            let a = 0;
            if ($(".cart__meta")
                .length == 0) {
                return;
            }
            $(".cart__meta").each(function(e) {
                    if ($(this)
                        .data("customer-b2b")) {
                        if ($(this)
                            .data("b2b")) {
                            b2b_products[$(this)
                                .data("variant-id")] = new Object();
                            b2b_products[$(this)
                                    .data("variant-id")]["quantity"] = $(this)
                                .data("quantity");
                            b2b_products[$(this)
                                    .data("variant-id")]["handle"] = $(this)
                                .data("handle");

                        } else {
                            b2c_products[$(this)
                                .data("variant-id")] = new Object();
                            b2c_products[$(this)
                                    .data("variant-id")]["quantity"] = $(this)
                                .data("quantity");
                            b2c_products[$(this)
                                    .data("variant-id")]["handle"] = $(this)
                                .data("handle");

                        }
                    } else {
                        if ($(this)
                            .data("b2b")) {
                            remove_cart[$(this)
                                .data("variant-id")] = 0;
                        }
                    }
                    obj.cart[a] = {
                        "sku": $(this)
                            .data("sku"),
                        "quantity": $(this)
                            .data("quantity"),
                        "id": $(this)
                            .data("id"),
                        "price": $(this)
                            .data("price")
                    }
                    a++
            })


            if ($(".cart-row[data-forprofile='false']").length > 0) {
        
                var wrong_profile = new Object();
                $(".cart-row[data-forprofile='false']")
                    .each(function() {
                        var data = $(this)
                            .find(".cart__meta");
                        wrong_profile[$(data)
                            .data("id")] = 0;
                    })
                var size = Object.keys(wrong_profile)
                    .length;
                if (size > 0) {
                    $(".cart-alert")
                        .html("Existem produtos que não podem ser vendidos para o seu perfil, eles seram removidos em 5 segundos.")
                        .show();
                    $(".product_type_company")
                        .removeClass("d-none");
                    $("#regular-checkout").addClass("d-none");
                    setTimeout(function() {
                        removeItem(wrong_profile);
                    }, 5000)
                    return;
                }
            }
            

            if (Object.keys(remove_cart).length > 0) {
                $(".cart-alert").html("Não pode ter productos B2B no seu carrinho, eles serão removidos em 5 segundos.").show();
                $(".product_type_company").removeClass("d-none");
                $("#regular-checkout").addClass("d-none");
                setTimeout(function() {
                    removeItem(remove_cart);
                }, 5000)
                return;
            }


            $("a.btn-remove").click(function(e) {
                  let $cartMeta = $(this).closest('.cart-row').find('.cart__meta');
                  let variantId = $cartMeta.data('variant-id') || $cartMeta.data('id');
                  if (variantId) {
                    removeStoredRequestedQty(variantId);
                  }
                    if ($("#card_id")
                        .val() != "") {

                        e.stopPropagation();
                        e.preventDefault();
                        $("#cards")
                            .val("");
                        $("#card_discount")
                            .val("");
                        $("#card_id")
                            .val("");

                        //location.href=$(this).attr("href");
                        var ref = $(this)
                            .parent()
                            .parent()
                            .data("sku")
                        $("#CartFormPage tr[data-sku=" + ref + "] .cart-product-quantity input")
                            .val(0);
                        $("#CartFormPage")
                            .submit();
                        return;
                    }
            })

            $(".cheques-remove").click(function() {
                    $("#regular-checkout").remove();
                    $("#update-cart")
                        .show();
                    $("#cards-line")
                        .remove();
                    $("#cards")
                        .val("");
                    $("#card_discount")
                        .val("");
                    $("#card_id")
                        .val("");
                    $("#cart-extended .cart-extended-handler")
                        .html('O carrinho de compras foi alterado. O carrinho será atualizado automaticamente...')
                    //$("#cart-extended .counter").hide();
                    $("#CartFormPage")
                        .submit();
            })
            //console.log("AQUI")
            $(".cart-product-quantity input").change(function(e) {
                    var isUserChange = Boolean(e.originalEvent && e.originalEvent.isTrusted !== false) || $(this).data("incmUserChange") === true;
                    if (!isUserChange) return;
                    $(this).removeData("incmUserChange");
              //console.log("atualizando quantidade")
                    //$("#regular-checkout").remove();
                    //$("#update-cart").show();
                    $("#cards-line").remove();
                    $("#cards").val("");
                    $("#card_discount").val("");
                    $("#card_id").val("");
                    $("#cart-extended .cart-extended-handler").html('O carrinho de compras foi alterado. Necessita de atualizar o carrinho!')
                    //$("#cart-extended .feedback").html('O carrinho de compras foi alterado. Necessita de atualizar o carrinho!')
                    //$("#cart-extended .cart-extended-handler input").prop("disabled",true)
                    //$("#cart-extended .counter").hide();
                    $("#regular-checkout").remove();
                    $("#update-cart")
                        .prop("disabled", false)
                        .removeAttr("disabled")
                        .show();
            })
          
            $("#cart-extended .cart-extended-handler")
                .html('<div class="loading"><i class="fa fa-spinner fa-spin"></i></div>')
            $("#CartFormPage button[type=submit]")
                .prop("disabled", true)

            var tt = parseFloat($(".cartCost").data("price") / 100)


         
           
           async function withCartToken() {
             //console.log("LOADED")
                const all = await getCart();
                //const cartToken = await getCartToken();
                const cartToken = all.token
                //console.log("all",all)
                //console.log("all token: "+all.token)
                //console.log("cart token: "+cartToken)
                if (cartToken) {

                console.log("stock validation xxx",obj)
              
                $.post(ENDPOINT, {
                    action: "stock_validation",
                    id: $("#cart-extended").data("id"),
                    cart: obj.cart,
                    token:cartToken,
                    uid:INCMUID,
                    value: tt,
                    store: STORE,
                    all:all
                })
                .done(function(data) {
                    
                    data = JSON.parse(data);

                    cleanStaleRequestedQty(all.items);
                    
                    if (data.remove && data.remove.length > 0) {
                        console.log("data-remove",data.remove);
                        removeItemsFromCart(data.remove)
                        //remove_cart[$(this).data("variant-id")] = 0;
                        //removeItem(remove_cart);
                        //location.reload();
                        

                    } else if (data.status == 1) {
                    
                        console.log("STOCK VALIDATION DONE")

                        $(".cart__meta").each(function() {
                            if ($(this).attr("data-credito") == "true" && $(this).attr("data-customer-b2b") == "false") {
                                $("#regular-checkout").addClass("d-none");
                                $(".cart-alert").html("O seu carrinho <strong>vai ser limpo</strong> em 5 segundos uma vez que não pode encomendar a crédito.").show();
                                var items = new Object();
                                $(".cart__meta")
                                    .each(function() {
                                        if ($(this)
                                            .attr("data-b2b") == "true") {
                                            items[$(this)
                                                .attr("data-id")] = 0;
                                        }
                                    })
                                setTimeout(function() {
                                    removeItem(items);
                                }, 5000)
                                return;
                            }
                        })


                       
                        if (Object.keys(b2c_products).length) {
                          console.log("Encontrados "+Object.keys(b2c_products).length+" produtos B2C")
                        }
                        if (Object.keys(b2c_products).length) {
                          console.log("Encontrados "+Object.keys(b2b_products).length+" produtos B2B")
                        }
                        
                        if (Object.keys(b2c_products).length > 0 && Object.keys(b2b_products).length > 0) {
                            localStorage.setItem("b2b_prods", JSON.stringify(b2b_products));
                            localStorage.setItem("b2c_prods", JSON.stringify(b2c_products));

                            $(".cart-alert").html("O seu carrinho contem produtos que não estão sujeitos a crédito. <br>Escolha entre os dois carrinhos qual pretende.").show();
                            $(".product_type_company").removeClass("d-none");
                            $(".choose_type").removeClass("d-none");
                            
                            // Remover event listeners antigos
                            // Ação única de checkout, executada pelo listener em fase de captura.
                            setRegularCheckoutAction(function(e) {
                                e.preventDefault();
                                
                                // Verificar qual opção está ativa
                                let isB2BSelected = $(".show_products_b2b.active").length > 0;
                                
                                console.log("B2B selecionado:", isB2BSelected);
                                
                                if (isB2BSelected) {
                                    // Carrinho B2B - remover produtos B2C
                                    var items_cart = JSON.parse(localStorage.getItem("b2c_prods") || "{}");
                                    var itemsToRemove = {};
                                    
                                    for (var id in items_cart) {
                                        itemsToRemove[id] = 0;
                                    }
                                    
                                    console.log("Removendo produtos B2C:", itemsToRemove);
                                    removeItem(itemsToRemove, creditCheckoutUrl);
                                    
                                } else {
                                    // Carrinho B2C - remover produtos B2B
                                    var items_cart = JSON.parse(localStorage.getItem("b2b_prods") || "{}");
                                    var itemsToRemove = {};
                                    
                                    for (var id in items_cart) {
                                        itemsToRemove[id] = 0;
                                    }
                                    
                                    console.log("Removendo produtos B2B:", itemsToRemove);
                                    removeItem(itemsToRemove, "/checkout");
                                }
                            });
                            
                            // Event listeners para os botões de escolha
                            $(".show_products_b2c").off("click").on("click", function() {
                                $(".choose_type span").removeClass("active");
                                $(this).addClass("active");
                                $(".cart-row[product_type='true']").addClass("d-none");
                                $(".cart-row[product_type='false']").removeClass("d-none");
                            });
                            
                            $(".show_products_b2b").off("click").on("click", function() {
                                $(".choose_type span").removeClass("active");
                                $(this).addClass("active");
                                $(".cart-row[product_type='false']").addClass("d-none");
                                $(".cart-row[product_type='true']").removeClass("d-none");
                            });
                            
                            // Inicializar com B2C selecionado
                            $(".show_products_b2c").click();
                            return;
                        }
                        $("#regular-checkout").attr("type", "button");

                        setRegularCheckoutAction(function(e) {
                           e.preventDefault();

                          
                           $.post(ENDPOINT, {
                              action: "flash_check",
                              cart: obj.cart,
                              store: STORE
                          })
                          .done(function(data) {
                    
                                  data = JSON.parse(data);

                                  if (data.status == 1) {

                          
                                        //document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                                        if ($(".cart__meta[data-customer-b2b='true']").length > 0) {
                                          if ($(".choose_type").hasClass("d-none") == false) {
                                            if ($(".show_products_b2b.active").length > 0) {
                                                window.location.assign(creditCheckoutUrl);
                                            } else {
                                              
                                                $("#CartFormPage").attr("action", encodeURI("/checkout")).submit();
                                            }
                                          } else {
                                            if ($(".cart__meta[data-customer-b2b='true']").length == $(".cart-row").length && $(".cart__meta[data-customer-b2b='true']").length == $(".cart__meta[data-b2b='true']").length) {
                                              
                                             
                                                window.location.assign(creditCheckoutUrl);
                                            } else {
                                               
                                            
                                                $("#CartFormPage").attr("action", encodeURI("/checkout")).submit();
                                            }
                                          }
                                        } else {
                                    
                                            $("#CartFormPage").attr("action", encodeURI("/checkout")).submit();
                                        }

                                    } else {
                                      //console.log(data)
                                      if (data.status==0 && data.available>0){
                                        //console.log("Só pode comprar "+data.available+" artigos do produto com a referência «"+data.sku+"»")
                                      } else {
                                        //console.log("O produto com a referência «"+data.sku+"» já se encontra esgotado")
                                      }
                                    }
                              })
                              .fail(function(data) {
                                //console.log(data)
                              })
                        })




                      
                      
                        $("#CartFormPage button[type=submit]").prop("disabled", false);

                        if (data.cart && data.cart.length) {
                            var msgList = [];
                            var cartUpdates = {};
                            var correctedItems = [];

                            for (var i = 0; i < data.cart.length; i++) {
                                var stockItem = data.cart[i];
                                var sku = String(stockItem.sku || "");
                                var allowedQty = parseInt(stockItem.quantity, 10);

                                if (isNaN(allowedQty)) {
                                    continue;
                                }

                                /*
                                * Evita usar diretamente:
                                * $(".cart__meta[data-sku=" + sku + "]")
                                *
                                * porque referências com espaços ou caracteres especiais
                                * podem partir o seletor CSS.
                                */
                                var $cartMeta = $(".cart__meta").filter(function() {
                                    return String($(this).data("sku") || "") === sku;
                                }).first();

                                if (!$cartMeta.length) {
                                    continue;
                                }

                                var variantId = String(
                                    $cartMeta.data("variant-id") ||
                                    $cartMeta.data("id") ||
                                    ""
                                );

                                var requestedFromCart = parseInt(
                                    $cartMeta.data("quantity"),
                                    10
                                ) || 0;

                                var lastRequested = getStoredRequestedQty(variantId);

                                if (lastRequested === undefined || lastRequested === null) {
                                    lastRequested = requestedFromCart;
                                }

                                lastRequested = parseInt(lastRequested, 10) || 0;

                                console.log("Resposta stock_validation:", data.cart);
                                console.log("Carrinho Shopify:", all.items);

                                /*
                                * Procura a linha correspondente no carrinho obtido por getCart().
                                * A line item key é mais segura do que utilizar apenas o variant ID.
                                */
                                var cartLine = all.items.find(function(item) {
                                    var itemVariantId = String(
                                        item.variant_id ||
                                        item.id ||
                                        ""
                                    );

                                    return (
                                        String(item.sku || "") === sku &&
                                        (!variantId || itemVariantId === variantId)
                                    );
                                });

                                if (!cartLine) {
                                    console.error(
                                        "Não foi encontrada a linha do carrinho para o SKU:",
                                        sku
                                    );
                                    continue;
                                }

                                var currentQuantity =
                                    parseInt(cartLine.quantity, 10) || 0;

                                /*
                                * A Shopify pode limitar a quantidade antes desta validação.
                                * Nesse caso, o carrinho já contém a quantidade permitida,
                                * mas ainda devemos avisar se o pedido original era superior.
                                * Quando o pedido e a quantidade final são iguais (por exemplo,
                                * 120 → 120), não é apresentada qualquer mensagem.
                                */
                                if (currentQuantity <= allowedQty) {
                                    removeStoredRequestedQty(variantId);
                                    continue;
                                }

                                if (lastRequested < currentQuantity) {
                                    lastRequested = currentQuantity;
                                }

                                var updateKey = String(
                                    cartLine.key ||
                                    cartLine.variant_id ||
                                    cartLine.id
                                );

                                cartUpdates[updateKey] = allowedQty;

                                var msg =
                                    "Solicitou " +
                                    lastRequested +
                                    " artigo(s), mas apenas " +
                                    allowedQty +
                                    " pode(m) ser servido(s) do produto «" +
                                    sku +
                                    "».";

                                msgList.push(msg);

                                correctedItems.push({
                                    key: updateKey,
                                    sku: sku,
                                    variantId: variantId,
                                    quantity: allowedQty
                                });

                                $cartMeta
                                    .children(".ref-stock")
                                    .html(msg)
                                    .css("color", "#f00");

                                /*
                                * Atualização apenas visual enquanto decorrem os 5 segundos.
                                * A atualização real é feita abaixo através de cart/update.js.
                                */
                                $cartMeta
                                    .closest(".cart-row")
                                    .find(".cart-product-quantity input")
                                    .val(allowedQty);
                            }

                            if (
                                msgList.length &&
                                Object.keys(cartUpdates).length &&
                                !window.cartStockCorrectionPending
                            ) {
                                window.cartStockCorrectionPending = true;

                                $(".cart-alert")
                                    .html(msgList.join("<br>"))
                                    .show();

                                showCartQuantityAlert(msgList.join("<br>"));

                                $("#regular-checkout").hide();

                                $("#update-cart")
                                    .show()
                                    .prop("disabled", true);

                                setTimeout(async function() {
                                    try {
                                        var cartRoot =
                                            window.Shopify &&
                                            window.Shopify.routes &&
                                            window.Shopify.routes.root
                                                ? window.Shopify.routes.root
                                                : "/";

                                        var response = await fetch(
                                            cartRoot + "cart/update.js",
                                            {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "Accept": "application/json"
                                                },
                                                body: JSON.stringify({
                                                    updates: cartUpdates
                                                })
                                            }
                                        );

                                        var updatedCart = await response.json();

                                        if (!response.ok) {
                                            throw new Error(
                                                updatedCart.description ||
                                                updatedCart.message ||
                                                "Não foi possível atualizar o carrinho."
                                            );
                                        }

                                        /*
                                        * Confirma que as quantidades foram efetivamente alteradas
                                        * antes de limpar o localStorage e recarregar.
                                        */
                                        var failedCorrection = correctedItems.find(function(correction) {
                                            return !isCartCorrectionConfirmed(updatedCart, correction);
                                        });

                                        if (failedCorrection) {
                                            throw new Error(
                                                "A Shopify não confirmou a nova quantidade do produto «" +
                                                failedCorrection.sku +
                                                "»."
                                            );
                                        }

                                        correctedItems.forEach(function(item) {
                                            removeStoredRequestedQty(item.variantId);
                                        });

                                        window.location.reload();
                                    } catch (error) {
                                        console.error(
                                            "Erro ao corrigir as quantidades do carrinho:",
                                            error
                                        );

                                        window.cartStockCorrectionPending = false;

                                        $(".cart-alert")
                                            .append(
                                                "<br>Não foi possível atualizar automaticamente " +
                                                "o carrinho. Atualize-o novamente."
                                            )
                                            .show();

                                        $("#update-cart")
                                            .show()
                                            .prop("disabled", false);
                                    }
                                }, 5000);

                                return;
                            }
                        }
                        /*
                        if (adjusted && adjusted.length) {
                            $("#cart-extended .cart-extended-handler")
                                .html("O carrinho de compras tem de ser atualizado...");
                            return false;
                        }
                            */
                        if (data.cards.length) {
                            $("#cart-extended")
                                .show();
                            var html = '<p>' + data.msg + '</p>';

                            html += '<ul>';
                            for (var i = 0; i < data.cards.length; i++) {
                                html += '<li><input type="checkbox" id="' + data.cards[i].id + '" data-id="' + data.cards[i].id + '" data-value="' + data.cards[i].value + '"> <label for="' + data.cards[i].id + '">' + data.cards[i].id + ' - ' + data.cards[i].value + '€</label></li>';
                            }
                            html += '</ul>';

                            //html+='<p class="text-center"><button class="btn btn-primary">Adicionar Desconto ao Carrinho</button></p>';

                            //$(".counter .discount").html("0€");

                            var total = parseInt($(".cartCost")
                                .data("price")) / 100;
                            //$(".counter2 .total").html(total+"€");


                        } else {
                            $("#cart-extended .cart-extended-handler")
                                .html('<div class="warning">' + data.msg + '</div>')
                        }
                        $("#cart-extended .cart-extended-handler")
                            .html(html);
                        var discount = 0;




                        $("#cart-extended input[type=checkbox]")
                            .click(function() {

                                $("#regular-checkout").remove();
                                $("#update-cart").show();

                            })



                        //$("#cart-extended .counter").show()




                        $("#cart-extended ul input[type=checkbox]")
                            .change(function() {
                                $("#cart-extended .feedback")
                                    .html("");


                                discount = 0;
                                $("#cart-extended ul input")
                                    .each(function() {

                                        if ($(this).is(":checked")) {

                                            if (discount + parseFloat($(this).data("value")) > total) {
                                                $(this).prop("checked", false)
                                                $("#cart-extended .feedback").html("Não é possível aplicar desconto superior ao valor da encomenda");
                                                return false;
                                            }
                                            discount += parseFloat($(this).data("value"));
                                        }

                                    })


                                let disc = Math.round((discount) * 100) / 100;
                                //$(".counter .discount").html(disc+"€");
                                let totalwdisc = Math.round((total - discount) * 100) / 100;
                                //$(".counter2 .total").html(totalwdisc+"€");
                                /*
                                if (discount>0){
                                  $("#cart-extended input[type=button]").prop("disabled",false)
                                } else {
                                  $("#cart-extended input[type=button]").prop("disabled",true)
                                }
                                */
                                var disc_comma = disc.toString()
                                    .replace(".", ",")
                                //$(".cheques-total").html("-€"+disc_comma)
                                //$("#CartFormPage").submit()
                                updateCardsSelected()


                            })




                        initCardsSelected()

                        $("#update-cart").click(function(e) {
                        
                                e.preventDefault();
                                e.stopPropagation();
                                /*
                                if ($("#cards").val()==""){
                                  $("#cart-extended .feedback").html("Não tem nenhum cheque-desconto selecionado!");
                                  return false;
                                }*/


                                if ($("#cart-extended input[type=checkbox]").length) {


                               
                                    $("#cart-extended button").prepend('<i class="fa fa-spinner fa-spin"></i> ') .prop("disabled", true)
                                    $("#cart-extended .feedback").html("");
                             
                                    $("#regular-checkout").prop("disabled",true)
                                  
                                    if (discount>0){
                                      var cheques_selecionados = [];
                                        $("#cart-extended ul input:checked").each(function() {
                                            cheques_selecionados.push($(this).data("id")); // só os IDs, não os valores
                                        });
                                      $.post(ENDPOINT, {
                                            action: "apply_discount",
                                            id: $("#cart-extended").data("id"),
                                            discount: discount,
                                            store: STORE,
                                            token: $("#cart-extended").data("token"),
                                            cheques: cheques_selecionados  
                                        })
                                        .done(function(data) {
                                          
                                          $("#regular-checkout").prop("disabled",false)
                                          
                                            var cards_selected = updateCardsSelected()

                                            data = JSON.parse(data)
                             
                                            if (data.status == 1 && data.code != "") {
                                                $("#card_id").val(data.code)

                                                $("#CartFormPage").attr("action", encodeURI("/checkout?discount="+data.code)).submit();  
                                                document.cookie = 'discount_code='+data.code;
                                            } else {
                                                $("#cart-extended .feedback").html(data.msg);
                                            }
                                          
                                            $("#cart-extended input[type=button] i").remove()

                                        })
                                        .fail(function(data) {
                                          $("#regular-checkout").prop("disabled",false)
                                            $("#cart-extended input[type=button] i").remove()
                                            $("#cart-extended .feedback").html("Não foi possível processar o seu pedido. Atualize a página e tente novamente");

                                        })
                                      
                                        //return false; // HOJE
                                      
                                      } else {
                                      
                                        // No caso de não haver cheques
                                        $("#card_id").val("")
                                        //document.cookie = 'discount_code=';
                                        $("#CartFormPage").submit()
                                        
                                      }
                                      
                                } else {
                                  // Isto estava comentado 
                                  $("#CartFormPage").submit()
                                  //$("#CartFormPage").attr("action", encodeURI("/checkout")).submit();
                                }


                            })



                    } else {
  
                        
                        $("#cart_feedback").addClass("active").html(data.msg);
                        //$("#cart-extended .feedback").html(data.msg);
                        $("#cart-extended .loading").remove();
                    }
                })
                .fail(function(data) {
                     
                    $("#cart-extended .feedback")
                        .html("Não foi possível realizar a verificação. Atualize a página e tente novamente");
                    $("#cart-extended .loading")
                        .remove();
                    return false // HOJE
                })


                  
                } else {
                    console.warn('Não foi possível obter o cartToken. Tratamento alternativo.');
                    // ... código alternativo ou tratamento de erro ...
                }
            }


          
            withCartToken()
            // Chamada da função principal após o carregamento do DOM
            //document.addEventListener('DOMContentLoaded', withCartToken);
        } // FIM DE CART EXTENDED



  
        
});

function initCardsSelected() {
   
    var cards_selected = [];

    if ($("#cards")
        .val() != "") {
        var card_fields = $("#cards")
            .val();
        if (card_fields != "") {
            card_fields = card_fields.split(",");
            var card_discount = 0;
            for (var i = 0; i < card_fields.length; i++) {
                if ($(".cart-extended-handler input[data-id=" + card_fields[i] + "]")
                    .length) {

                    $(".cart-extended-handler input[data-id=" + card_fields[i] + "]")
                        .prop("checked", true)
                        .trigger("change")
                    card_discount += $(".cart-extended-handler input[data-id=" + card_fields[i] + "]")
                        .data("value")
                    cards_selected.push(card_fields[i])

                }
            }
       
            $("#card_discount")
                .val(card_discount)
            /*
              if (card_fields.length!=cards_selected.length){
                $("#cards").val("")
                $("#CartFormPage").submit();

              }
              */

        }


    }



    return cards_selected;

}

function updateCardsSelected() {

   
    var new_selection = [];
    var card_discount = 0;
    $(".cart-extended-handler input[type=checkbox]")
        .each(function() {
            if ($(this)
                .is(":checked")) {
                new_selection.push($(this)
                    .data("id"))
                card_discount += $(this)
                    .data("value")
            }

        })

    $("#cards")
        .val(new_selection)
    $("#card_discount")
        .val(card_discount)
    if ($("#card_id")
        .val() != "") {
        $("#cart-extended .cart-extended-handler button")
            .html("Atualizar desconto");
    }
    return new_selection;

}

function removeItemsFromCart(lineItemIds) {
  // Criar um array de objetos que indica os itens a remover (quantidade 0)
  const itemsToRemove = lineItemIds.map(lineItemId => ({
    id: lineItemId,
    quantity: 0  // Definir quantidade 0 para remover
  }));

  // Enviar a requisição para remover os itens
  fetch('/cart/update.js', {
    method: 'POST',
    body: JSON.stringify({
      updates: itemsToRemove.reduce((updates, item) => {
        updates[item.id] = item.quantity;
        return updates;
      }, {})
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    alert("Alguns dos produtos no seu carrinho estão com informação inválida ou incompleta. Os produtos em causa serão removidos do carrinho.");

    // Atualizar a interface do carrinho
    location.reload();
  })
  .catch(error => {
    console.error('Erro ao remover os itens do carrinho', error);
  });
}

function VerifyNif(nif, country) {

    $.get("https://incm.bydascloud.com/", {
            action: "validate_nif",
            nif: nif,
            country: country,
            store: STORE,
            client_id:$(".change_nif .customer_id")[0].innerText,
            token: $(".change_nif .input_nif").attr("data-token"),
        })
        .done(function(data) {
            data = JSON.parse(data);
        
            if (data.status == 1) {
                //FUNÇÃO QUE INICIA O PROCESSO DE ALTERAÇÃO DE NIF
                StartProcessChangeNif(true);
            } else {
                $(".responses_update .error_update")
                    .removeClass("d-none");
                $(".responses_update .error_update")
                    .addClass("d-block");
                $(".responses_update .ok_update")
                    .addClass("d-none");
                $(".responses_update .ok_update")
                    .removeClass("d-block");
                $(".responses_update .same_nif")
                    .addClass("d-none");
                $(".responses_update .same_nif")
                    .removeClass("d-block");
                $(".responses_update .error_update")
                    .append("<span> - " + data.msg + "</span>");
                //FUNÇÃO QUE INICIA O PROCESSO DE ALTERAÇÃO DE NIF
                StartProcessChangeNif(false);
            }

            return false;


        })

    return false;

}

function ChangeNif(customer_id, new_nif) {
    $.post(ENDPOINT, {
            action: "update_nif",
            client_id: customer_id,
            nif: new_nif,
            store: STORE,
            token: $(".change_nif .input_nif").attr("data-token"),
        })
        .done(function(data) {
            data = JSON.parse(data);
            // stauts 0 -> erro // status 1 -> ja existe e é igual // status 2 -> criado/update
            if (data.status == 0) {
                $(".responses_update .error_update")
                    .removeClass("d-none");
                $(".responses_update .error_update")
                    .addClass("d-block");
                $(".responses_update .ok_update")
                    .addClass("d-none");
                $(".responses_update .ok_update")
                    .removeClass("d-block");
                $(".responses_update .same_nif")
                    .addClass("d-none");
                $(".responses_update .same_nif")
                    .removeClass("d-block");
            } else if (data.status == 1) {
                $(".responses_update .same_nif")
                    .removeClass("d-none");
                $(".responses_update .same_nif")
                    .addClass("d-block");
                $(".responses_update .ok_update")
                    .addClass("d-none");
                $(".responses_update .ok_update")
                    .removeClass("d-block");
                $(".responses_update .error_update")
                    .addClass("d-none");
                $(".responses_update .error_update")
                    .removeClass("d-block");
            } else if (data.status == 2) {
                $(".responses_update .same_nif")
                    .addClass("d-none");
                $(".responses_update .same_nif")
                    .removeClass("d-block");
                $(".responses_update .error_update")
                    .addClass("d-none");
                $(".responses_update .error_update")
                    .removeClass("d-block");
                $(".responses_update .ok_update")
                    .removeClass("d-none");
                $(".responses_update .ok_update")
                    .addClass("d-block");
            }
        })
}

function StartProcessChangeNif(nifValidate) {

    if (nifValidate) {
        //NIF PRONTO PARA SER ALTERADO
        var new_nif = $(".change_nif .input_nif")
            .val();
        var customer_id = $(".change_nif .customer_id")[0].innerText;
    
        //FUNÇÃO QUE ATUALIZA A TAG DE NIF DE CLIENTE
        ChangeNif(customer_id, new_nif);

    } else {
        //O NIF NAO ESTAVA CORRECTO
        setTimeout(function() {
            $(".responses_update .error_update")
                .addClass("d-none");
            $(".responses_update .error_update")
                .removeClass("d-block");
            $(".responses_update .error_update span")
                .remove();
        }, 5000)

    }

}

function autoCartAddProduct() {

    var cartLinnes = window.location.search.split("?auto=");
    cartLinnes = cartLinnes[cartLinnes.length - 1];
    cartLinnes = cartLinnes.split("&");
    cartLinnes[1] = unescape(cartLinnes[1])
        .replace("%2C", ",")
        .replaceAll("+", " ");
    var itemsToAdd = new Array();
    var line_item = new Object();
    line_item["id"] = cartLinnes[0];
    line_item["quantity"] = 1;
    line_item["properties"] = new Object();
    cartLinnes[1] = cartLinnes[1].split("&");

  

    cartLinnes[1].forEach((item) => {

        item = item.split("=");
        line_item["properties"][item[0]] = decodeURI(item[1]);

   

    });



    itemsToAdd.push(line_item);

    jQuery.post('/cart/add.js', {
            items: itemsToAdd
        })
        .done(function(e) {

            if (sessionStorage.getItem("autoCart") == undefined) {
                sessionStorage.setItem('autoCart', line_item["id"]);
            } else {
                var cookie = sessionStorage.getItem("autoCart");
                if (cookie.includes(line_item["id"]) == false) {
                    cookie += "," + line_item["id"];
                    sessionStorage.setItem("autoCart", cookie);
                }
            }
            sessionStorage.setItem("infoLivroReclamacao", JSON.stringify(line_item));

            window.location.pathname = "/cart";

        })
        .
    fail((e) => {
        //console.log(e);
    })



}

function clearCookies() {

    sessionStorage.removeItem("autoCart");
    sessionStorage.removeItem("infoLivroReclamacao");

}


function VerfiyWindowSize() {

    if ($(window)
        .width() > 768) {
        $("#shopify-section-header-mobile")
            .remove();
    }


}

function addItemCart(items, destination = "") {
 

    
    $.post('/cart/add.js', {
            items: items
        }, null, "json")
        .then(function(data) {
    
            if (destination == "") {
                window.location.pathname = "/cart";
            } else {
                window.location.href = destination;
            }
        })
        .fail(function(error) {
            //console.log(error);
        })
}

function removeItem(items, destination = "") {
    console.log("removeItem chamado:", items, destination);
    
    // Verificar se items é um objeto e não está vazio
    if (!items || Object.keys(items).length === 0) {
        console.log("Nenhum item para remover, redirecionando...");
        if (destination) {
            window.location.href = destination;
        }
        return;
    }
    
    $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        data: { updates: items },
        dataType: 'json',
        success: function(data) {
            console.log("Itens removidos com sucesso:", data);
            if (destination && destination !== "") {
                window.location.href = destination;
            } else {
                window.location.href = "/cart";
            }
        },
        error: function(error) {
            console.error("Erro ao remover itens:", error);
            window.location.href = "/cart";
        }
    });
}
$(document)
    .on('click', ".menu-toggle", function() {
        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/animejs/2.0.2/anime.js")
    })


async function old_cart_B2B_clientes() {
 
    await getCart()
        .then(async function(cart) {
            if (cart.items.length == 0 && ((localStorage.getItem("b2c_prods") != undefined && localStorage.getItem("b2b_prods") == undefined) || (localStorage.getItem("b2c_prods") == undefined && localStorage.getItem("b2b_prods") != undefined))) {
                var b2c_prds = localStorage.getItem("b2c_prods");
                if (b2c_prds != undefined) {
                    var type = "B2C";
                    var old_cart_items = JSON.parse(b2c_prds);
                } else {
                    var type = "B2B";
                    var old_cart_items = localStorage.getItem("b2b_prods");
                    if (old_cart_items != undefined) {
                        old_cart_items = JSON.parse(old_cart_items);
                    } else {
                        return;
                    }
                }
                var products = new Array();
                var update_cart = new Array();
                for (const id in old_cart_items) {
                    var line_cart = new Object();
                    var product = old_cart_items[id];
                    line_cart["id"] = id;
                    line_cart["quantity"] = product.quantity;
                    update_cart.push(line_cart);
                    await get_product_by_handle(product.handle)
                        .then(response => {
                            response["cart_quantity"] = product.quantity;
                            response["type"] = type;
                            products.push(response);
                        })
                }
                show_old_cart(products);

                $(".add_old_cart")
                    .click(function() {
                        localStorage.removeItem(type.toLowerCase() + "_prods");
                        addItemCart(update_cart);
                    })

                $(".forget_old_cart")
                    .click(function() {
                        localStorage.removeItem(type.toLowerCase() + "_prods");
                        $(".popup_decide_b2c_b2b")
                            .addClass("d-none");
                    })
            }
        })

}

function show_old_cart(products) {
    var lines = "";

    for (var i in products) {
        var product = products[i];
        var img = "";
        var price = "";

        if (product.images[0] != undefined) {
            img = product.images[0].src;
        }

        product.variants.map(variant => {
            if (variant.option1 == product.type) {
                price = variant.price;
            }
        })

        var line = `<tr>
                        <td class="text-center">                
                                <img class="img-fluid" src="` + img + `">
                        </td>
                        <td class=text-center">
                                <p>` + product.title + `</p>
                        </td>
                        <td class="text-center">
                                <p>` + price + `€</p>
                        </td>
                        <td class="text-center">
                                <p>` + product.cart_quantity + `</p>
                        </td>
        </tr>`;

        lines += line;
    }

    $(".popup_decide_b2c_b2b .lines")
        .html(lines);

    $(".popup_decide_b2c_b2b")
        .removeClass("d-none");

}
async function get_product_by_handle(handle) {
    return new Promise((resolve, reject) => {
        $.get('https://loja.incm.pt/products/' + handle + ".json", null, "json")
            .then(function(product) {
                resolve(product.product);
            })
            .fail(function(error) {
                reject(error)
            })
    })
}

async function getCart() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: '/cart.js',
            method: 'GET',
            dataType: 'json',
            success: function(cart) {
                resolve(cart);
            },
            error: function(error) {
                reject(error);
            }
        });
    });
}

function getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


function removeUpdateTags() {
    sessionStorage.removeItem("customer_update");
}

function updateTags(customer) {
    var customer_update = sessionStorage.getItem("customer_update");
    if (customer_update == undefined) {
        $.get(ENDPOINT, {
                store: STORE,
                customer_id: customer,
                action: "customer"
            })
            .done(function(res) {
                sessionStorage.setItem("customer_update", true);
            })
    }
}

// Obriga clientes Shopify incompletos a completar o registo antes de comprar.
function checkCustomerProfile(customer) {
    var path = window.location.pathname.replace(/\/$/, "");
    if (path !== "/account" && !/\/account$/.test(path)) return;

    $.get(ENDPOINT, {
        action: "check_customer_profile",
        customer_id: customer,
        store: STORE
    }).done(function (response) {
        if (typeof response === "string") {
            try { response = JSON.parse(response); } catch (e) { return; }
        }
        if (response && response.status == 1 && response.incomplete) {
            sessionStorage.setItem("customer_profile_id", customer);
            if (response.email) sessionStorage.setItem("customer_profile_email", response.email);
            var registerPath = path.indexOf("/en/") === 0 ? "/en/account/register" : "/account/register";
            var notice = path.indexOf("/en/") === 0
                ? "Your account is incomplete. You will now be redirected to complete your registration."
                : "A sua conta está incompleta. Será reencaminhado para completar o registo.";
            window.alert(notice);
            window.location.href = registerPath + "?complete=1&customer_id=" + encodeURIComponent(customer) + "#register";
        } else {
            updateTags(customer);
        }
    });
}

function SendTrackToMiddleware(content) {
    var time = new Date();
    content["store"] = 1;
    content["url"] = window.location.href;
    content["timestamp"] = time.getTime();
    content["browser"] = window.navigator.appVersion;
    content["action"] = "log_client";

}

async function getCartToken() {

    try {
        const resposta = await fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        if (!resposta.ok) {
            throw new Error(`Erro na requisição: ${resposta.status}`);
        }

        const dadosCarrinho = await resposta.json();
        const cartToken = dadosCarrinho.token;

        //console.log('Cart Token atual:', cartToken);
        return cartToken;
    } catch (erro) {
        //console.error('Erro ao obter o cart_token:', erro);
        return null;
    }
}

/* ----------------------------------------------------
   INCM AJAX ADD TO CART + MINI-CART
---------------------------------------------------- */
(function () {
  var incmMiniCartInitTimer = null;

  function initINCMMiniCartAjax() {
    if (window.INCMMiniCartAjax) {
      if (incmMiniCartInitTimer) {
        clearInterval(incmMiniCartInitTimer);
        incmMiniCartInitTimer = null;
      }

      return true;
    }

    var $incm =
      window.jQuery ||
      window.$ ||
      (typeof $jqMolla !== "undefined" ? $jqMolla : null);

    if (!$incm) {
      return false;
    }

  (function ($) {
    function formatMoney(cents) {
      cents = parseInt(cents || 0, 10);

      if (
        typeof window.theme !== "undefined" &&
        theme.Currency &&
        typeof theme.Currency.formatMoney === "function"
      ) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }

      return "€" + (cents / 100).toFixed(2).replace(".", ",");
    }

    function escapeHtml(value) {
      if (value === null || value === undefined) {
        return "";
      }

      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function getItemImage(item) {
      if (!item.image) {
        return "";
      }

      return item.image.replace(/(\.(jpg|jpeg|png|gif|webp))(\?v=.*)?$/i, "_60x40_crop_center$1$3");
    }

    function buildCartItemHtml(item) {
      var itemId = item.id;
      var itemKey = item.key || item.id;
      var itemTitle = item.product_title || item.title || "";
      var itemUrl = item.url || "#";
      var itemImage = getItemImage(item);
      var variationHtml = "";
      var imageHtml = "";

      if (item.options_with_values && item.options_with_values.length) {
        item.options_with_values.forEach(function (option) {
          if (
            option.name &&
            option.value &&
            option.value !== "Default Title"
          ) {
            variationHtml +=
              '<span class="variation" title="' +
              escapeHtml(item.title) +
              '">' +
              '<span class="option_title">' +
              escapeHtml(option.name) +
              ": </span>" +
              escapeHtml(option.value) +
              "</span>";
          }
        });
      } else if (item.variant_title && item.variant_title !== "Default Title") {
        variationHtml +=
          '<span class="variation" title="' +
          escapeHtml(item.title) +
          '">' +
          escapeHtml(item.variant_title) +
          "</span>";
      }

      if (itemImage) {
        imageHtml =
          '<img class="lazyloaded" alt="' +
          escapeHtml(item.title || itemTitle) +
          '" src="' +
          escapeHtml(itemImage) +
          '">';
      }

      return (
        '<li class="item__' +
        itemId +
        ' d-flex flex-nowrap justify-content-between" data-cart-key="' +
        escapeHtml(itemKey) +
        '">' +
        '<div class="card" style="display:none"><div class="bar-loading ifinite"></div></div>' +
        '<div class="info_itemCart info">' +
        '<div class="product-name">' +
        '<a href="' +
        escapeHtml(itemUrl) +
        '" title="' +
        escapeHtml(itemTitle) +
        '">' +
        escapeHtml(itemTitle) +
        "&nbsp;</a>" +
        "</div>" +
        variationHtml +
        '<span class="price">' +
        item.quantity +
        "x " +
        formatMoney(
          typeof item.original_price === "number"
            ? item.original_price
            : item.price
        ) +
        "</span>" +
        "</div>" +
        '<div class="thumb-wrapper d-flex flex-nowrap align-items-center">' +
        '<div class="thumb">' +
        imageHtml +
        "</div>" +
        '<a href="javascript:void(0)" data-cart-key="' +
        escapeHtml(itemKey) +
        '" data-variant-id="' +
        escapeHtml(itemId) +
        '" class="remove-item remove" title="Remover">X</a>' +
        "</div>" +
        "</li>"
      );
    }

    function getMiniCartTotalCents(cart) {
      return typeof cart.original_total_price === "number"
        ? cart.original_total_price
        : cart.total_price;
    }

    function updateMiniCartHeader(cart) {
      $(".cartCount").text(cart.item_count);

      var totalCents = getMiniCartTotalCents(cart);

      $(".mini-cart .cartCost")
        .attr("data-price", totalCents)
        .html(formatMoney(totalCents));
    }

    function renderMiniCartItems(cart) {
      var $miniCarts = $(".mini-cart");
      var $lists = $miniCarts.find(".ajax__list-cart");

      if (!$lists.length) {
        return;
      }

      var html = "";

      if (cart.items && cart.items.length) {
        cart.items.forEach(function (item) {
          html += buildCartItemHtml(item);
        });
      }

      $lists
        .removeClass("loading")
        .toggleClass("has-item", cart.item_count > 0)
        .html(html);

      $miniCarts.find(".SubTotal, .Viewcart, .has-item").show();
      $miniCarts.find(".no-item").hide();

      if (cart.item_count <= 0) {
        $miniCarts.find(".SubTotal, .Viewcart, .has-item").hide();
        $miniCarts.find(".no-item").show();
      }

      var totalCents = getMiniCartTotalCents(cart);

      $miniCarts.find(".SubTotal .cartCost")
        .attr("data-price", totalCents)
        .html(formatMoney(totalCents));

      if (
        typeof window.theme !== "undefined" &&
        theme.function &&
        theme.function.multiCurrency === true &&
        typeof Kt_currency !== "undefined" &&
        typeof localStorageCurrency !== "undefined" &&
        typeof shopCurrency !== "undefined" &&
        localStorageCurrency !== null &&
        localStorageCurrency !== shopCurrency
      ) {
        Kt_currency.convertAll(
          shopCurrency,
          localStorageCurrency,
          ".mini-cart span.money, .mini-cart .cartCost"
        );
      }
    }

function openMiniCartDropdown() {
  var $miniCart = $(".mini-cart");
  var $drop = $miniCart.find(".show-shopping-cart, .kiti--DropInner");

  if (!$miniCart.length || !$drop.length) {
    return;
  }

  $(".kiti--DropItem.show").not($miniCart).removeClass("show");

  clearTimeout(window.__incmMiniCartCloseTimer);

  $miniCart
    .addClass("show")
    .addClass("mini-cart-open")
    .removeClass("load");

  $drop.css({
    display: "block",
    opacity: 1,
    visibility: "visible",
    pointerEvents: "auto"
  });
}

function closeMiniCartDropdown() {
  clearTimeout(window.__incmMiniCartCloseTimer);

  var $miniCart = $(".mini-cart");
  var $drop = $miniCart.find(".show-shopping-cart, .kiti--DropInner");

  $miniCart
    .removeClass("show")
    .removeClass("mini-cart-open");

  $drop.css({
    display: "",
    opacity: "",
    visibility: "",
    pointerEvents: ""
  });
}

function refreshMiniCart(cart, noticeMessage) {
  if (!cart) {
    $.getJSON("/cart.js", function (freshCart) {
      refreshMiniCart(freshCart, noticeMessage);
    });

    return;
  }

  updateMiniCartHeader(cart);
  renderMiniCartItems(cart);
  $(".mini-cart .icon-link").removeClass("load");

  if (noticeMessage) {
    showMiniCartNotice(noticeMessage);
  } else {
    clearMiniCartNotice();
  }

  setTimeout(function () {
    openMiniCartDropdown();
  }, 50);
}

    function getFormVariantId($form) {
      var id = parseInt($form.find('[name="id"]').first().val(), 10);
      return isNaN(id) ? null : id;
    }

    function getFormQuantity($form) {
      var qty = parseInt($form.find('[name="quantity"]').first().val(), 10);
      return isNaN(qty) || qty < 1 ? 1 : qty;
    }

    function getFormMaxQuantity($form) {
      var $qty = $form.find('[name="quantity"]').first();

      var values = [
        $qty.attr("max"),
        $qty.attr("data-max"),
        $qty.data("max")
      ];

      for (var i = 0; i < values.length; i++) {
        var max = parseInt(values[i], 10);

        if (!isNaN(max) && max > 0) {
          return max;
        }
      }

      return null;
    }

    function cleanFormBeforeSerialize($form) {
      $form.find(".checkInputs input").each(function () {
        var value = $(this).val();

        if (value !== "") {
          $(this).val($.trim(value));
        }
      });
    }

    function showCartError(message) {
      if (
        typeof window.KT !== "undefined" &&
        typeof KT.errorAlert === "function"
      ) {
        KT.errorAlert(message);
        return;
      }

      alert(message);
    }

    function canAddRequestedQuantity(variantId, quantity, maxQuantity, callback) {
      if (!maxQuantity) {
        callback(true);
        return;
      }

      $.getJSON("/cart.js", function (cart) {
        var currentQty = 0;

        $.each(cart.items || [], function (_, item) {
          if (parseInt(item.id, 10) === parseInt(variantId, 10)) {
            currentQty += parseInt(item.quantity, 10) || 0;
          }
        });

        callback(currentQty + quantity <= maxQuantity);
      }).fail(function () {
        callback(true);
      });
    }

    function getCartItemQuantity(cart, variantId) {
        var quantity = 0;

        $.each(cart.items || [], function (_, item) {
            if (parseInt(item.id, 10) === parseInt(variantId, 10)) {
            quantity += parseInt(item.quantity, 10) || 0;
            }
        });

        return quantity;
    }

    function clearMiniCartNotice() {
        clearTimeout(window.__incmMiniCartNoticeTimer);
        window.__incmMiniCartNoticeTimer = null;

        $(".mini-cart .incm-mini-cart-notice")
            .stop(true, true)
            .remove();
    }

    function showMiniCartNotice(message) {
        var $drop = $(".mini-cart").find(".show-shopping-cart, .kiti--DropInner");

        if (!$drop.length) {
            return;
        }

        clearMiniCartNotice();

        var html =
            '<div class="incm-mini-cart-notice" style="' +
            "font-size:13px;" +
            "line-height:1.4;" +
            "padding:10px 12px;" +
            "margin-bottom:10px;" +
            "background:#fff3cd;" +
            "border:1px solid #ffeeba;" +
            "color:#856404;" +
            '">' +
            escapeHtml(message) +
            "</div>";

        $drop.each(function () {
            var $target = $(this);
            var $list = $target.find(".ajax__list-cart").first();

            if ($list.length) {
                $list.before(html);
            } else {
                $target.prepend(html);
            }
        });

        window.__incmMiniCartNoticeTimer = setTimeout(function () {
            var $notice = $drop.find(".incm-mini-cart-notice");

            $notice.fadeOut(300, function () {
                $(this).remove();
            });
        }, 10000);
    }

    function getCurrentQuantityInCart(variantId, callback) {
        $.getJSON("/cart.js", function (cart) {
            callback(cart, getCartItemQuantity(cart, variantId));
        }).fail(function () {
            callback(null, 0);
        });
    }

    function parseStockValidationResponse(response) {
      if (typeof response !== "string") {
        return response;
      }

      try {
        return JSON.parse(response);
      } catch (error) {
        console.error("Resposta inválida da validação de stock:", error);
        return null;
      }
    }

    function getMiniCartCustomerId() {
      return (
        $("#cart-extended").data("id") ||
        $("body").attr("data-customer") ||
        ""
      );
    }

    function buildStockValidationCart(cart) {
      return $.map(cart.items || [], function (item) {
        return {
          sku: item.sku || "",
          quantity: parseInt(item.quantity, 10) || 0,
          id: item.variant_id || item.id,
          key: item.key || "",
          price: typeof item.original_price === "number"
            ? item.original_price
            : item.price || 0
        };
      });
    }

    function getRequestedQuantityForNotice(item) {
      var currentQuantity = parseInt(item.quantity, 10) || 0;
      var variantId = item.variant_id || item.id;
      var requestedQuantity =
        typeof window.getStoredRequestedQty === "function"
          ? parseInt(getStoredRequestedQty(variantId), 10)
          : 0;

      return requestedQuantity > currentQuantity
        ? requestedQuantity
        : currentQuantity;
    }

    function clearRequestedQuantities(items) {
      if (typeof window.removeStoredRequestedQty !== "function") {
        return;
      }

      $.each(items || [], function (_, item) {
        removeStoredRequestedQty(item.variant_id || item.id);
      });
    }

    function getStockEntryIdentity(stockItem) {
      var stockKey = String(stockItem.key || "");
      var stockId = String(stockItem.id || stockItem.variant_id || "");

      if (stockKey) {
        return "key:" + stockKey;
      }

      if (stockId) {
        return "id:" + stockId;
      }

      return "sku:" + String(stockItem.sku || "");
    }

    function findCartItemsForStockEntry(cart, stockItem) {
      var stockKey = String(stockItem.key || "");
      var stockSku = String(stockItem.sku || "");
      var stockId = String(stockItem.id || stockItem.variant_id || "");

      return $.grep(cart.items || [], function (item) {
        var itemKey = String(item.key || "");
        var itemId = String(item.variant_id || item.id || "");

        if (stockKey) {
          return itemKey === stockKey;
        }

        var sameSku = stockSku && String(item.sku || "") === stockSku;
        var sameId = stockId && itemId === stockId;

        return sameSku || sameId;
      });
    }

    function addRemovalUpdates(cart, removeList, updates) {
      $.each(removeList || [], function (_, removeEntry) {
        var removeId = String(
          typeof removeEntry === "object"
            ? removeEntry.key || removeEntry.id || removeEntry.variant_id || ""
            : removeEntry
        );

        $.each(cart.items || [], function (_, item) {
          var itemId = String(item.variant_id || item.id || "");
          var itemKey = String(item.key || "");

          if (removeId && (removeId === itemId || removeId === itemKey)) {
            updates[item.key || item.id] = 0;
          }
        });
      });
    }

    function stockAdjustmentNotice(sku, requestedQuantity, allowedQuantity) {
      return "A quantidade do produto «" + String(sku || "") +
        "» foi ajustada de " + requestedQuantity + " para " + allowedQuantity +
        ", conforme o stock disponível.";
    }

    function validateMiniCartStock(cart, callback) {
      if (
        !cart ||
        !cart.items ||
        !cart.items.length ||
        typeof window.ENDPOINT === "undefined"
      ) {
        callback(cart, "");
        return;
      }

      $.post(ENDPOINT, {
        action: "stock_validation",
        id: getMiniCartCustomerId(),
        cart: buildStockValidationCart(cart),
        token: cart.token,
        uid: typeof INCMUID !== "undefined" ? INCMUID : "",
        value: (parseInt(getMiniCartTotalCents(cart), 10) || 0) / 100,
        store: typeof window.STORE !== "undefined" ? STORE : 0,
        all: cart
      })
        .done(function (response) {
          var data = parseStockValidationResponse(response);

          if (!data) {
            callback(
              cart,
              "Não foi possível confirmar o stock disponível. Tente novamente."
            );
            return;
          }

          var updates = {};
          var messages = [];
          var stockEntryCounts = {};
          var usedCartItemKeys = {};

          addRemovalUpdates(cart, data.remove, updates);

          if (data.remove && data.remove.length) {
            messages.push(
              "Foram removidos do carrinho produtos sem informação válida ou disponível."
            );
          }

          $.each(data.cart || [], function (_, stockItem) {
            var stockIdentity = getStockEntryIdentity(stockItem);
            stockEntryCounts[stockIdentity] =
              (stockEntryCounts[stockIdentity] || 0) + 1;
          });

          $.each(data.cart || [], function (_, stockItem) {
            var allowedQuantity = parseInt(stockItem.quantity, 10);

            if (isNaN(allowedQuantity) || allowedQuantity < 0) {
              return;
            }

            var stockIdentity = getStockEntryIdentity(stockItem);
            var matchingItems = findCartItemsForStockEntry(cart, stockItem);
            var lineByLine =
              Boolean(stockItem.key) || stockEntryCounts[stockIdentity] > 1;

            if (lineByLine) {
              var matchingItem = null;

              $.each(matchingItems, function (_, item) {
                var itemKey = String(item.key || item.id || "");

                if (!usedCartItemKeys[itemKey]) {
                  matchingItem = item;
                  usedCartItemKeys[itemKey] = true;
                  return false;
                }
              });

              matchingItems = matchingItem ? [matchingItem] : [];
            }

            var currentQuantity = 0;

            $.each(matchingItems, function (_, item) {
              currentQuantity += parseInt(item.quantity, 10) || 0;
            });

            if (!matchingItems.length || currentQuantity <= allowedQuantity) {
              return;
            }

            var remainingQuantity = allowedQuantity;
            var requestedQuantity = currentQuantity;

            $.each(matchingItems, function (_, item) {
              var itemQuantity = parseInt(item.quantity, 10) || 0;
              var correctedQuantity = Math.min(itemQuantity, remainingQuantity);

              if (!lineByLine) {
                requestedQuantity = Math.max(
                  requestedQuantity,
                  getRequestedQuantityForNotice(item)
                );
              }

              remainingQuantity = Math.max(
                0,
                remainingQuantity - correctedQuantity
              );

              if (correctedQuantity !== itemQuantity) {
                updates[item.key || item.id] = correctedQuantity;
              }
            });

            if (stockItem.source === "sale_limit") {
              messages.push("Não pode adicionar mais de " + stockItem.limit + " unidades deste produto.");
            } else {
            messages.push(
              stockAdjustmentNotice(stockItem.sku, requestedQuantity, allowedQuantity)
            );
            }
          });

          if (!Object.keys(updates).length) {
            callback(cart, "");
            return;
          }

          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: JSON.stringify({ updates: updates }),
            contentType: "application/json",
            dataType: "json",
            success: function (updatedCart) {
              clearRequestedQuantities(cart.items);
              callback(updatedCart, messages.join(" "));
            },
            error: function () {
              callback(
                cart,
                "Não foi possível ajustar o carrinho ao stock disponível. Atualize a página e tente novamente."
              );
            }
          });
        })
        .fail(function () {
          callback(
            cart,
            "Não foi possível confirmar o stock disponível. Atualize a página e tente novamente."
          );
        });
    }

    function validateAndRefreshMiniCart(cart, fallbackNotice) {
      validateMiniCartStock(cart, function (validatedCart, validationNotice) {
        refreshMiniCart(validatedCart, validationNotice || fallbackNotice || "");
      });
    }

    function getRemoveCartKey(removeLink) {
      var $link = $(removeLink);
      var key = $link.attr("data-cart-key");

      if (key) {
        return key;
      }

      key = $link.closest("[data-cart-key]").attr("data-cart-key");

      if (key) {
        return key;
      }

      var inlineHandler = $link.attr("onclick") || "";
      var match = inlineHandler.match(/KT_removeItem\(['\"]([^'\"]+)/);

      return match ? match[1] : "";
    }

    function removeMiniCartItem(removeLink) {
      var cartKey = getRemoveCartKey(removeLink);

      if (!cartKey || $(removeLink).data("incmRemoving")) {
        return;
      }

      clearMiniCartNotice();
      $(removeLink).data("incmRemoving", true);
      $(removeLink).closest("li").find("div.card").show(100);

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { id: cartKey, quantity: 0 },
        dataType: "json",
        success: function (cart) {
          if (typeof window.removeStoredRequestedQty === "function") {
            removeStoredRequestedQty(
              $(removeLink).attr("data-variant-id") || cartKey
            );
          }

          validateAndRefreshMiniCart(cart, "");
        },
        error: function () {
          $.getJSON("/cart.js", function (cart) {
            refreshMiniCart(
              cart,
              "Não foi possível remover o produto do carrinho. Tente novamente."
            );
          });
        },
        complete: function () {
          $(removeLink).data("incmRemoving", false);
        }
      });
    }

    function ajaxAddFormToCart($form, $button) {
        if (!$form.length || $form.data("incmAjaxAdding")) {
            return;
        }

        clearMiniCartNotice();

        if (
            $form.is("#cart-form--product-template2") &&
            $(".not_ipq").length > 0
        ) {
            showCartError(
            "Este produto não pode ser adquirido com o seu perfil de cliente."
            );
            return;
        }

        var variantId = getFormVariantId($form);
        var requestedQuantity = getFormQuantity($form);
        var maxQuantity = getFormMaxQuantity($form);

        if (!variantId) {
            return;
        }

        cleanFormBeforeSerialize($form);

        var formElement = $form.get(0);

        if (
            formElement &&
            typeof formElement.checkValidity === "function" &&
            !formElement.checkValidity()
        ) {
            if (typeof formElement.reportValidity === "function") {
                formElement.reportValidity();
            }

            return;
        }

        getCurrentQuantityInCart(variantId, function (cartBefore, currentQuantity) {
            var quantityToAdd = requestedQuantity;
            var noticeMessage = "";

            if (maxQuantity) {
            var availableToAdd = maxQuantity - currentQuantity;

            if (availableToAdd <= 0) {
                noticeMessage =
                "Já tem no carrinho a quantidade máxima disponível deste produto.";

                if (cartBefore) {
                validateAndRefreshMiniCart(cartBefore, noticeMessage);
                } else {
                refreshMiniCart(null, noticeMessage);
                }

                return;
            }

            if (requestedQuantity > availableToAdd) {
                quantityToAdd = availableToAdd;

                noticeMessage =
                "A quantidade pedida foi ajustada para " +
                quantityToAdd +
                ", porque não existe stock suficiente para adicionar " +
                requestedQuantity +
                " unidade(s).";
            }
            }

            $form.data("incmAjaxAdding", true);

            if ($button && $button.length) {
            $button.addClass("loading").prop("disabled", true);
            }

            if (typeof window.storeRequestedQty === "function") {
            storeRequestedQty(variantId, currentQuantity + requestedQuantity);
            }

            var $quantityInput = $form.find('[name="quantity"]').first();
            var originalQuantityValue = $quantityInput.val();

            if ($quantityInput.length) {
            $quantityInput.val(quantityToAdd);
            }

            var formData = $form.serialize();

            if ($quantityInput.length) {
            $quantityInput.val(originalQuantityValue);
            }

            $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            dataType: "json",
            success: function (addedItem) {
                var addedVariantId = parseInt(
                addedItem && (addedItem.variant_id || addedItem.id),
                10
                );

                if (isNaN(addedVariantId)) {
                addedVariantId = variantId;
                }

                var quantityBeforeAdd = getCartItemQuantity(
                cartBefore || { items: [] },
                addedVariantId
                );

                if (
                addedVariantId !== variantId &&
                typeof window.storeRequestedQty === "function"
                ) {
                storeRequestedQty(
                    addedVariantId,
                    quantityBeforeAdd + requestedQuantity
                );

                if (typeof window.removeStoredRequestedQty === "function") {
                    removeStoredRequestedQty(variantId);
                }
                }

                $.getJSON("/cart.js", function (cart) {
                var finalQuantity = getCartItemQuantity(cart, addedVariantId);
                var expectedQuantity = quantityBeforeAdd + requestedQuantity;

                if (finalQuantity >= expectedQuantity) {
                    noticeMessage = "";
                } else {
                    noticeMessage = stockAdjustmentNotice(
                      addedItem.sku || addedItem.product_title || addedVariantId,
                      expectedQuantity,
                      finalQuantity
                    );
                }

                validateAndRefreshMiniCart(cart, noticeMessage);
                });
            },
            error: function (xhr) {
                var message = "Não foi possível adicionar o produto ao carrinho.";

                if (xhr.responseJSON) {
                message =
                    xhr.responseJSON.description ||
                    xhr.responseJSON.message ||
                    message;
                }

                $.getJSON("/cart.js", function (cart) {
                var finalQuantity = getCartItemQuantity(cart, variantId);
                var expectedQuantity = currentQuantity + requestedQuantity;
                var stockError = xhr.status === 422 && (
                  finalQuantity > currentQuantity ||
                  /stock|invent|disponib|maximum|maxim|máxim|can't add more|sold out/i.test(message)
                );
                if (stockError && finalQuantity > 0 && finalQuantity < expectedQuantity) {
                    var cartItem = $.grep(cart.items || [], function (item) {
                      return parseInt(item.variant_id || item.id, 10) === variantId;
                    })[0];
                    message = stockAdjustmentNotice(
                      cartItem.sku || cartItem.product_title || variantId,
                      expectedQuantity,
                      finalQuantity
                    );
                }
                refreshMiniCart(cart, message);
                }).fail(function () {
                showCartError(message);
                });
            },
            complete: function () {
                $form.data("incmAjaxAdding", false);

                if ($button && $button.length) {
                $button.removeClass("loading").prop("disabled", false);
                }
            }
            });
        });
    }

    window.INCMMiniCartAjax = {
      refresh: refreshMiniCart,
      open: openMiniCartDropdown,
      close: closeMiniCartDropdown,
      addForm: ajaxAddFormToCart,
      updateHeader: updateMiniCartHeader,
      renderItems: renderMiniCartItems
    };

    document.addEventListener(
      "click",
      function (event) {
        var button = event.target.closest(
          '.addItemAjax, .single_add_to_cart_button, .validate_stock_cart, .validate_stock_cart_grid, form[action*="/cart/add"] button[type="submit"]'
        );

        if (!button) {
          return;
        }

        var form = button.closest('form[action*="/cart/add"]');

        if (!form || !form.querySelector('[name="id"]')) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        ajaxAddFormToCart($(form), $(button));
      },
      true
    );

    document.addEventListener(
      "click",
      function (event) {
        var removeLink = event.target.closest(".mini-cart .remove-item");

        if (!removeLink) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        removeMiniCartItem(removeLink);
      },
      true
    );

    document.addEventListener(
      "click",
      function (event) {
        var cartLink = event.target.closest(".mini-cart .icon-link");

        if (!cartLink) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        $(cartLink).addClass("load");

        $.getJSON("/cart.js", function (cart) {
          validateAndRefreshMiniCart(cart, "");
        }).fail(function () {
          $(cartLink).removeClass("load");
          openMiniCartDropdown();
        });
      },
      true
    );

    $(document)
      .off("submit.incmMiniCartAjax")
      .on(
        "submit.incmMiniCartAjax",
        'form[action*="/cart/add"]',
        function (event) {
          var $form = $(this);

          if (!$form.find('[name="id"]').length) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          ajaxAddFormToCart(
            $form,
            $form
              .find(
                '.addItemAjax, .single_add_to_cart_button, button[type="submit"]'
              )
              .first()
          );
        }
      );

    $(document)
      .off("click.incmMiniCartAjaxClose")
      .on("click.incmMiniCartAjaxClose", function (event) {
        if ($(event.target).closest(".mini-cart").length) {
          return;
        }

        closeMiniCartDropdown();
      });
    })($incm);

    if (incmMiniCartInitTimer) {
      clearInterval(incmMiniCartInitTimer);
      incmMiniCartInitTimer = null;
    }

    return true;
  }

  if (!initINCMMiniCartAjax()) {
    var initAttempts = 0;

    incmMiniCartInitTimer = setInterval(function () {
      initAttempts += 1;

      if (initINCMMiniCartAjax() || initAttempts >= 200) {
        clearInterval(incmMiniCartInitTimer);
        incmMiniCartInitTimer = null;
      }
    }, 50);

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        initINCMMiniCartAjax,
        { once: true }
      );
    }
  }
})();
/* FIM INCM AJAX ADD TO CART + MINI-CART */
